<template>
  <section v-loading="loading" id="view-test-information" class="default-modal">
    <div class="case-creation__card" v-loading="!!viewReportLoadingId">
      <div class="case-creation__step case-creation__test">
        <div class="attachments"></div>
      </div>
      <div
        v-if="
          getTestReportsData &&
          getTestReportsData.length == 0 &&
          displayUploading == false
        "
        class="no-test-block"
      >
        No test reports found
      </div>
      <div
        v-if="isLabUser || isClientSalesUser"
        class="test-tabs reportsTableWidth"
        id="vue-tabs"
      >
        <!-- Case-level Report Notes Panel -->
        <div class="report-notes-panel">
          <span class="notes-label">Notes</span>
          <el-popover
            v-for="(note, idx) in (getCaseInformation && getCaseInformation.report_notes || [])"
            :key="idx"
            placement="bottom-start"
            :width="260"
            trigger="click"
          >
            <template #reference>
              <span class="note-chip">{{ note.title }}</span>
            </template>
            <div class="note-popover-content">
              <p class="note-popover-desc">{{ note.description }}</p>
              <p class="note-popover-meta">{{ note.added_by_name }} &bull; {{ formatNoteDate(note.added_at) }}</p>
            </div>
          </el-popover>
          <span v-if="getCaseInformation && getCaseInformation.status !== 'COMPLETE' && !(getCaseInformation.report_notes && getCaseInformation.report_notes.length >= 1)" class="note-add-trigger" @click="openNotesDialog" title="Add Note">+ Add</span>
        </div>

        <el-tabs
          v-model="activeName"
          class="demo-tabs"
          @tab-click="updateSelectedTabQuery"
        >
          <el-tab-pane
            label="Upload Documents"
            name="uploadFiles"
            v-if="
              getCaseInformation &&
              getCaseInformation.status != 'COMPLETE' &&
              displayUploading &&
              hasPermission('cases', 'report_upload_new_version')
            "
          >
            <UploadTestReports
              v-on:uploadedTestReports="checkCaseInformation"
              :selectedCaseId="caseIdProp"
            >
            </UploadTestReports>
          </el-tab-pane>
          <el-tab-pane
            :table-props="{ height: 'calc(100vh - 300px)' }"
            class="table-border"
            v-for="(caseType, index) of caseTypes"
            :key="index"
            :label="caseType.name"
            :name="index + ''"
          >
            <div class="test-panel">
              <div class="primary-content-view-new" v-loading="loading">
                <div
                  class="listings listings__table listings__all-cases"
                  id="all-cases-listings"
                >
                  <el-table :data="caseType.reports" style="width: 100%">
                    <el-table-column
                      prop="action"
                      label="REPORTS"
                      :width="
                        hasPGXCase
                          ? '300'
                          : isLabAssistant
                          ? '750'
                          : '550'
                      "
                    >
                      <template #default="scope">
                        <ul class="action-test-icons view-test">
                          <li
                            style="margin-right: 10px"
                            v-if="
                              scope.row.case_type == 'COVID' ||
                              scope.row.case_type == 'COVID_FLU' ||
                              scope.row.case_type == 'WOUND' ||
                              scope.row.case_type == 'NAIL' ||
                              scope.row.case_type == 'GASTRO'
                            "
                          >
                            <div
                              class="column-status"
                              v-if="scope.row.covid_status"
                            >
                              <span class="el-dropdown-link">
                                <el-tag
                                  :type="
                                    getCovidStatusType(scope.row.covid_status)
                                  "
                                  >{{ scope.row.covid_status }}</el-tag
                                >
                              </span>
                            </div>
                          </li>
                          <li
                            style="margin-right: 10px"
                            v-if="
                              scope.row.case_type ==
                                'RESPIRATORY_PATHOGEN_PANEL' ||
                              scope.row.case_type == 'URINALYSIS' ||
                              scope.row.case_type == 'UTI' ||
                              scope.row.case_type == 'TOXICOLOGY' ||
                              scope.row.case_type == 'WOUND' ||
                              scope.row.case_type == 'NAIL' ||
                              scope.row.case_type == 'GASTRO'
                            "
                          >
                            <div
                              class="column-status"
                              v-if="scope.row.result_status"
                            >
                              <span class="el-dropdown-link">
                                <el-tag
                                  :type="
                                    getCovidStatusType(scope.row.result_status)
                                  "
                                  >{{ scope.row.result_status }}</el-tag
                                >
                              </span>
                            </div>
                          </li>
                         <li v-if="
                            scope.row.case_type == 'UTI' && displayUploading
                          ">
                            <el-button class="action-download" v-if="hasPermission('test_reports', 'view')"
                              @click="addAdditionalReport(scope.row)" title="
                                Additional Reports
                              ">
                              <span>
                                <img class="testreports-active" src="@/assets/images/icons/plus-icon.svg" alt="icon" />
                              </span>
                            </el-button>
                          </li>
                          <li
                            v-if="
                              !scope.row.is_supplemental_report ||
                              (scope.row.is_supplemental_report &&
                                scope.row.template_report_merged)
                            "
                          >
                            <el-button
                              class="action-download"
                              v-if="hasPermission('test_reports', 'download')"
                              @click="onDownloadReport(scope.row, false, false)"
                              title="Download"
                            >
                              <span>
                                <img
                                  v-if="!checkNewReport(scope.row)"
                                  class="testreports-active"
                                  src="@/assets/images/icons/Download_1.svg"
                                  alt="icon"
                                  style="width: 22px"
                                />
                                <img
                                  v-else
                                  class="testreports-active"
                                  src="@/assets/images/icons/Download_2.svg"
                                  alt="icon"
                                  style="width: 22px"
                                />
                              </span>
                            </el-button>
                          </li>
                          <li
                            v-if="
                              restrictRefreshReportAccess(
                                caseData,
                                getAuthenticatedUser,
                                scope.row
                              )
                            "
                          >
                            <el-tooltip content="Refresh Report" placement="top">
                              <el-button class="refresh-report-btn" type="text"
                                @click="$emit('refresh-report', scope.row)">
                                <el-icon class="refresh-icon">
                                   <img class="testreports-active" src="@/assets/images/icons/refresh-right.svg" alt="icon" />
                                </el-icon>
                              </el-button>
                            </el-tooltip>
                          </li>
                          <li
                            v-if="
                              !scope.row.is_supplemental_report ||
                              (scope.row.is_supplemental_report &&
                                scope.row.template_report_merged)
                            "
                          >
                            <el-button
                              class="action-view"
                              @click="viewReport(scope.row)"
                              title="View"
                            >
                              <img
                                v-if="!checkNewReport(scope.row)"
                                class="testreports-active"
                                src="@/assets/images/icons/view_1.svg"
                                alt="icon"
                                style="width: 22px"
                              />
                              <img
                                v-else
                                class="testreports-active"
                                src="@/assets/images/icons/view_2.svg"
                                alt="icon"
                                style="width: 22px"
                              />
                            </el-button>
                          </li>
                          <li v-if="displayUploading">
                            <el-button
                              class="action-delect"
                              v-if="
                                hasPermission('test_reports', 'delete_report')
                              "
                              @click="onDelete(scope.row)"
                              :disabled="checkEditDisable(scope.row)"
                              :title="
                                checkEditDisable(scope.row)
                                  ? 'Case is already finalized'
                                  : ''
                              "
                            >
                              <img
                                class="testreports-active"
                                src="@/assets/images/icons/actions/test-delect-active.svg"
                                alt="icon"
                              />
                            </el-button>
                          </li>
                          <li
                            v-if="
                              scope.row.case_type == 'URINALYSIS' &&
                              scope.row.mark_for_physician == true &&
                              (scope.row.ua_reflex_created && scope.row.ua_reflex_created === 'ELIGIBLE' ||
                                scope.row.ua_reflex_created === 'CREATED')
                            "
                          >
                            <el-button
                              v-if="scope.row.ua_reflex_created === 'ELIGIBLE'"
                              class="resend-notify-button replace"
                              title="Create UTI Reflex Case"
                              @click="handleUTICaseCreation()"
                            >
                              Create UTI Reflex
                            </el-button>
                            <span
                              v-else-if="scope.row.ua_reflex_created === 'CREATED'"
                              class="reflex-created-label"
                            >
                              Reflex Created
                            </span>
                          </li>
                          <li
                            v-if="
                              scope.row.case_type == 'TOXICOLOGY' &&
                              scope.row.result_file_id &&
                              displayUploading
                            "
                          >
                            <el-button
                              @click="onReportEdit(scope.row)"
                              :disabled="checkEditDisable(scope.row)"
                              :title="
                                checkEditDisable(scope.row)
                                  ? editBlockReason
                                  : 'Edit Report'
                              "
                            >
                              <img
                                class="action-active"
                                src="@/assets/images/icons/actions/edit-active.svg"
                                alt="icon"
                              />
                            </el-button>
                          </li>
                          <li
                            v-if="
                              ['UTI', 'STI', 'WOMENS_HEALTH'].includes(scope.row.case_type) &&
                              scope.row.result_file_id &&
                              !scope.row.is_supplemental_report
                            "
                          >
                            <el-button
                              class="resend-notify-button replace"
                              title="View Result File"
                              @click="onViewResultFile(scope.row)"
                            >
                              VIEW RF
                            </el-button>
                          </li>
                          <li
                            v-if="
                              scope.row.mark_for_physician &&
                              hasPermission('cases', 'report_resend_new') &&
                              isEligibleToSendFax &&
                              displayUploading
                            "
                          >
                            <el-button
                              class="resend-fax-button"
                              @click="chooseResendFaxOptions(scope.row)"
                              title="Resend Fax"
                            >
                              <img
                                class="testreports-active"
                                src="@/assets/images/icons/actions/resent-fax-new.svg"
                                alt="icon"
                              />
                            </el-button>
                          </li>
                          <li
                            v-if="
                              !scope.row.template_report_merged &&
                              displayUploading &&
                              scope.row.is_supplemental_report &&
                              hasPermission('test_reports', 'merge') &&
                              !isLabAssistantLogin
                            "
                          >
                            <el-button
                              @click="onGenerate(scope.row)"
                              class="resend-fax-button"
                              :disabled="
                                getCaseInformation &&
                                getCaseInformation.status == 'COMPLETE'
                              "
                              :title="
                                getCaseInformation &&
                                getCaseInformation.status == 'COMPLETE'
                                  ? editBlockReason || 'Case Finalized'
                                  : ''
                              "
                              >MERGE</el-button
                            >
                          </li>
                          <li
                            v-if="
                              (scope.row.emr_result_sent_status &&
                                scope.row.emr_result_sent_status != 'SENT' &&
                                this.getCaseInformation &&
                                this.getCaseInformation.emr_order &&
                                scope.row.mark_for_physician) ||
                              (!scope.row.uni_directional_sent_status &&
                                this.getCaseInformation.emr_order_type ==
                                  'UNIDIRECTIONAL' &&
                                hasPermission('cases', 'report_resend')) ||
                              isAbleToGenerateResendEMR
                            "
                          >
                            <el-tooltip
                              :content="
                                this.getCaseInformation.emr_failed_reason
                                  ? this.getCaseInformation.emr_failed_reason
                                  : ''
                              "
                              placement="top"
                              effect="dark"
                            >
                              <el-button
                                @click="resendEmr(scope.row)"
                                class="resend-fax-button"
                                >RESEND EMR</el-button
                              >
                            </el-tooltip>
                          </li>
                          <li
                            v-if="
                              this.getCaseInformation &&
                              this.getCaseInformation.status &&
                              this.getCaseInformation.status ==
                                'TEST_REPORTS' &&
                              scope.row.case_type == 'UTI' &&
                              scope.row.is_supplemental_report
                            "
                          >
                            <el-upload
                              v-if="scope.row.sendout_discrete_result_id"
                              action=""
                              :auto-upload="false"
                              accept=".csv"
                              :show-file-list="false"
                              @change="
                                ($event) => handleUpload($event, scope.row)
                              "
                            >
                              <el-button
                                class="resend-notify-button replace"
                                title="REPLACE DISCRETE RESULTS"
                              >
                                REPLACE
                              </el-button>
                            </el-upload>
                            <el-upload
                              v-else
                              action=""
                              :auto-upload="false"
                              accept=".csv"
                              :show-file-list="false"
                              @change="
                                ($event) => handleUpload($event, scope.row)
                              "
                              ><el-button
                                class="discrete-results-btn"
                                title="UPLOAD DISCRETE RESULTS"
                              >
                                DR
                              </el-button>
                            </el-upload>
                          </li>
                          <li
                            v-if="
                              scope.row.sendout_discrete_result_id &&
                              [
                                'UTI',
                                'STI',
                                'GASTRO',
                                'NAIL',
                                'WOMENS_HEALTH',
                                'WOUND',
                                'RESPIRATORY_PATHOGEN_PANEL',
                                'ENT',
                              ].includes(scope.row.case_type)
                            "
                          >
                            <el-button
                              class="resend-notify-button replace"
                              title="VIEW DISCRETE RESULTS"
                              @click="
                                viewDiscreteResults(
                                  scope.row.sendout_discrete_result_id
                                )
                              "
                            >
                              VIEW DR
                            </el-button>
                          </li>
                          <li
                            v-if="
                              scope.row.case_type == 'UTI' &&
                              scope.row.sendout_discrete_result_id
                            "
                          >
                            <el-button
                              class="resend-notify-button replace"
                              title="REMOVE DISCRETE RESULTS"
                              @click="
                                removeDiscreteResults(
                                  scope.row.sendout_discrete_result_id
                                )
                              "
                            >
                              REMOVE DR
                            </el-button>
                          </li>
                          <li
                            v-if="
                              this.getCaseInformation &&
                              this.getCaseInformation.is_sendout &&
                              !scope.row.sendout_discrete_result_id &&
                              this.getCaseInformation.sendout &&
                              this.getCaseInformation.sendout.received_lab &&
                              this.getCaseInformation.sendout.received_lab
                                .name == 'ADVANTA GENETICS'
                            "
                          >
                            <el-button
                              class="resend-notify-button replace"
                              title="GENERATE DISCRETE RESULTS"
                              @click="
                                generateDiscreteResultsForAdvanta(scope.row)
                              "
                            >
                              GENERATE DR
                            </el-button>
                          </li>
                          <li
                            v-if="
                              scope.row.case_type == 'CLINICAL_CHEMISTRY' &&
                              scope.row.report_pdf_id &&
                              hasPermission('cases', 'report_upload_new')
                            "
                          >
                            <el-button
                              class="resend-notify-button replace"
                              title="VIEW DISCRETE RESULTS"
                              @click="
                                genClinicalChemistryReportResults(
                                  scope.row.report_pdf_id
                                )
                              "
                            >
                              VIEW DR
                            </el-button>
                          </li>
                          <li
                            v-if="
                              isDLWUser &&
                              this.getCaseInformation &&
                              this.getCaseInformation.is_sendout
                            "
                          >
                            <el-button
                              class="resend-notify-button replace"
                              title="SENDOUT DR"
                              @click="
                                generateDiscreteForClinicalChemistry(scope.row)
                              "
                            >
                              SENDOUT DR
                            </el-button>
                          </li>
                          <li
                            v-if="
                              (scope.row.case_type == 'CLINICAL_CHEMISTRY' &&
                                this.getCaseInformation.is_labdaq_order &&
                                !this.getCaseInformation
                                  .labdaq_discrete_result_status &&
                                isDLWLab &&
                                !isCaseComplete &&
                                isSendoutCategory) ||
                              isAbleToGenerateResendEMR
                            "
                          >
                            <el-button
                              class="resend-notify-button replace"
                              title="GENERATE DISCRETE RESULTS"
                              @click="syncDiscreteResults(scope.row)"
                            >
                              SYNC DR
                            </el-button>
                          </li>
                          <li
                            v-if="
                              scope.row.case_type == 'URINALYSIS' &&
                              scope.row.sendout_discrete_result_id
                            "
                          >
                            <el-button
                              class="resend-notify-button replace"
                              title="VIEW DISCRETE RESULTS"
                              @click="
                                viewDiscreteResults(
                                  scope.row.sendout_discrete_result_id
                                )
                              "
                            >
                              VIEW DR
                            </el-button>
                          </li>
                          <li
                            v-if="
                              scope.row.case_type == 'TOXICOLOGY' &&
                              scope.row.sendout_discrete_result_id
                            "
                          >
                            <el-button
                              class="resend-notify-button replace"
                              title="VIEW DISCRETE RESULTS"
                              @click="
                                viewDiscreteResultsToxicology(
                                  scope.row.sendout_discrete_result_id
                                )
                              "
                            >
                              VIEW DR
                            </el-button>
                          </li>
                        </ul>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="time"
                      label="DATE & TIME"
                      :width="hasPGXCase ? '180' : '300'"
                    >
                      <template #default="scope">
                        <span>
                          {{
                            momentWithTimezone(
                              scope.row.time,
                              "MM-DD-YYYY hh:mm A"
                            )
                          }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="time"
                      label="Title"
                      width="400"
                      v-if="hasPGXCase"
                    >
                      <template #default="scope">
                        <el-button
                          placement="top"
                          class="title-on-hover"
                          :title="scope.row.title"
                        >
                          <span class="text-center ordering_facility-value">
                            {{ scope.row.title }}
                          </span>
                        </el-button>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="mark"
                      label="MARK FOR PHYSICIAN"
                      :width="hasPGXCase ? '285' : '300'"
                      v-if="displayUploading"
                    >
                      <template #default="scope">
                        <div class="physician-btn">
                          <el-switch
                            @change="
                              (value) =>
                                updateReportPhysicianStatus(value, scope.row)
                            "
                            :loading="validatingResultId === scope.row._id"
                            :disabled="
                              blockMarkForPhysician ||
                              getPrilimenaryReportGenerating ||
                              validatingResultId !== null ||
                              !hasPermission('test_reports', 'finalize_report') ||
                              (!scope.row.template_report_merged &&
                                scope.row.is_supplemental_report) ||
                              (!isCaseFinalized(scope.row) && isCaseComplete)
                            "
                            :model-value="scope.row.mark_for_physician"
                          ></el-switch>
                          <span
                            v-if="
                              getCaseInformation &&
                              getCaseInformation.sample_run_location
                            "
                            class="sample-run-location"
                          >
                            Sample run in
                            {{ getCaseInformation.sample_run_location }}
                          </span>
                          <!-- <span
                            v-if="
                              !scope.row.mark_for_physician &&
                              scope.row.report_id &&
                              scope.row.result_file_id &&
                              scope.row.test_results_id &&
                              hasToxicology &&
                              !isCaseComplete &&
                              hasPermission('cases', 'report_upload_new')
                            "
                          >
                            <span class="tox-finalize-btn">
                              <el-button @click="finalizeReport(scope.row)"
                                >Finalize</el-button
                              >
                            </span>
                          </span> -->
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="show_to_client"
                      label="SHOW TO CLIENT"
                      :width="120"
                      v-if="
                        hasPermission('cases', 'report_upload_new') &&
                        displayUploading &&
                        getCaseInformation?.case_types?.includes('TOXICOLOGY')
                      "
                    >
                      <template #default="scope">
                        <div
                          class="physician-btn"
                          v-if="scope.row.case_type == 'TOXICOLOGY'"
                        >
                          <el-switch
                            @change="
                              (value) =>
                                updateReportToClientStatus(value, scope.row)
                            "
                            :model-value="scope.row.report_to_client"
                          ></el-switch>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="type"
                      label="TYPE"
                      :width="hasPGXCase ? '160' : '270'"
                    >
                      <template #default="scope">
                        <span v-if="scope.row.is_supplemental_report == true"
                          >Supplemental Report</span
                        >
                        <span v-else-if="scope.row.is_amendement"
                          >Amendement Report</span
                        >
                        <span
                          v-else-if="
                            scope.row.is_priliminary_report && checkColonyLab
                          "
                          >Preliminary Report</span
                        >
                        <span
                          v-else-if="
                            checkColonyLab &&
                            scope.row.mark_for_physician == true &&
                            scope.row.case_type == 'CLINICAL_CHEMISTRY'
                          "
                          >Regular Report</span
                        >
                        <span
                          v-else-if="scope.row.is_priliminary_report"
                          >Preliminary Report
                        </span>
                        <span v-else>Regular Report</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="default-modal">
        <el-dialog
          v-model="askEmrConfig"
          width="30%"
          :before-close="handleEmrConfigClose"
          v-loading="loading"
        >
          <div class="dialog-header">
            <span class="header-part">EMR</span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="askEmrConfig = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
            </el-button>
          </div>
          <div class="popup-date pb-0">
            <div class="popup-el-select">
              <label>Result Status*:</label>
              <el-select
                v-model="emrResultStatus"
                placeholder="Select result status"
              >
                <el-option
                  v-for="item in resultStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="dialog-footer">
              <el-button class="cancel-button" @click="handleEmrConfigClose"
                >Cancel</el-button
              >
              <el-button class="blue-save-button" @click="sendToEmr"
                >Send to EMR</el-button
              >
            </div>
          </div>
        </el-dialog>
      </div>
      <div class="default-modal">
        <el-dialog
          v-model="askResendFaxConfigOptions"
          width="35%"
          :before-close="handleResendFaxConfigClose"
          class="vue-modal"
          v-loading="loading"
        >
          <div class="dialog-header">
            <span class="header-part">RESEND FAX</span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="askResendFaxConfigOptions = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
            </el-button>
          </div>
          <div class="fax-resend-popup">
            <el-form ref="form" :model="resendFaxConfig" label-width="150px">
              <el-form-item label="Ordering Facility" :required="true">
                <el-switch
                  v-model="resendFaxConfig.hospital"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="
                    getCheckFaxStatus && !getCheckFaxStatus.hospital_fax_status
                  "
                ></el-switch>
              </el-form-item>

              <el-form-item label="Referring Physician" :required="true">
                <el-switch
                  v-model="resendFaxConfig.referring_physician"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="
                    getCheckFaxStatus &&
                    !getCheckFaxStatus.referring_physician_fax_status
                  "
                ></el-switch>
              </el-form-item>
              <el-form-item label="Additional Fax">
                <div class="additionalFaxSelect">
                  <el-select
                    v-model="resendFaxConfig.additional_fax_numbers"
                    placeholder="Enter fax number"
                    clearable
                    create-new
                    allow-create
                    multiple
                    filterable
                  >
                    <el-option
                      v-for="faxNumber in resendFaxConfig.additional_fax_numbers"
                      :key="faxNumber"
                      :label="faxNumber"
                      :value="faxNumber"
                    />
                  </el-select>
                </div>
                <p
                  class="err"
                  v-if="getErrors && getErrors.additional_fax_numbers"
                >
                  {{ getErrors.additional_fax_numbers }}
                </p>
              </el-form-item>
            </el-form>
          </div>
          <div class="dialog-footer mt-5 mr-20">
            <el-button class="cancel-button" @click="handleResendFaxConfigClose"
              >CANCEL</el-button
            >
            <el-button
              class="blue-save-button"
              :disabled="
                !resendFaxConfig.hospital &&
                !resendFaxConfig.referring_physician &&
                !resendFaxConfig.additional_fax_numbers.length
              "
              @click="resendFax"
              :loading="loading"
              >RESEND FAX</el-button
            >
          </div>
        </el-dialog>
      </div>
      <div class="default-modal">
        <el-dialog
          v-model="additionalReportsPopup"
          width="40%"
          :before-close="handleAdditionalReportsClose"
          v-loading="loading"
        >
          <div class="dialog-header">
            <span class="header-part">ADDITIONAL REPORTS</span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="handleAdditionalReportsClose"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
            </el-button>
          </div>
          <div class="popup-date pb-0">
            <div class="upload-files-alignment-block">
              <div class="upload-files-alignment">
                <el-upload
                  class="upload-demo"
                  action
                  :on-remove="handleReportRemove"
                  :file-list="files"
                  :auto-upload="false"
                  accept=".pdf"
                  :multiple="true"
                  :on-change="handleMultipleFileUpload"
                  :show-file-list="false"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload-text-align">
                    <div class="el-upload__text-img">
                      <img
                        src="@/assets/images/icons/attachments-icon.svg"
                        alt
                      />
                    </div>
                    <div class="el-upload__text">
                      <h3>Drag & drop file here</h3>
                      <p>your file here, or browse</p>
                    </div>
                  </div>
                </el-upload>
              </div>
            </div>
            <div class="dialog-footer">
              <el-button
                class="cancel-button"
                @click="handleAdditionalReportsClose"
                >Cancel</el-button
              >
              <el-button
                class="blue-save-button"
                @click="sendAdditionalReports()"
                :loading="buttonLoading"
                :disabled="hasAdditionalReports"
                >Submit</el-button
              >
            </div>
            <div v-if="this.files && this.files.length">
              <div class="attach-upload-file">
                <h4>Attachment Files</h4>
              </div>
              <draggable
                v-model="files"
                @start="drag = true"
                @end="drag = false"
                ghost-class="ghost"
                item-key="id"
                class="upload-file"
              >
                <template #item="{ element, index }">
                  <div class="show-upload-file">
                    <img src="@/assets/images/icons/view-attach-icon.svg" alt />
                    <p class="upload-file-text">
                      {{ index + 1 + "-" + element.name }}
                    </p>
                    <el-button
                      @click="move(index, index - 1)"
                      :disabled="index == 0"
                      class="move-up-button"
                    >
                      <el-icon>
                        <top />
                      </el-icon>
                    </el-button>
                    <el-button
                      @click="move(index, index + 1)"
                      :disabled="index == files.length - 1"
                      class="move-button"
                    >
                      <el-icon>
                        <bottom />
                      </el-icon>
                    </el-button>
                    <el-button @click="remove(index)" class="close-button">
                      <el-icon>
                        <close />
                      </el-icon>
                    </el-button>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
        </el-dialog>
      </div>
      <div id="discrete_results_view_popup">
        <div class="default-modal">
          <el-dialog v-model="discreteResultsPopup" width="80%">
            <div class="dialog-header">
              <span class="header-part"> Discrete Results </span>
              <el-button
                size="medium"
                class="el-white"
                type="info"
                plain
                @click="discreteResultsPopup = false"
              >
                <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
              /></el-button>
            </div>
            <div class="all-cases-view">
              <div class="popup-date">
                <div class="primary-content-view-new" v-loading="loading">
                  <div
                    class="listings listings__table listings__all-cases"
                    id="all-cases-listings"
                    v-if="
                      this.discreteData &&
                      this.discreteData.length &&
                      this.discreteData.length > 0
                    "
                  >
                    <el-table :data="this.discreteData" height="425">
                      <el-table-column
                        :label="hasUrinalysis ? 'Result Name' : 'Display Name'"
                        prop="display_name"
                        width="200"
                      >
                        <template v-slot="{ row }">
                          <div class="name-accession">
                            <span id="accession-id">
                              {{
                                hasUrinalysis
                                  ? row.result_name
                                  : row.display_name
                              }}
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="hasUrinalysis ? 'EMR Code' : 'Assay Id'"
                        prop="assay_id"
                        width="200"
                      >
                        <template v-slot="{ row }">
                          <div class="patient-name">
                            {{
                              hasUrinalysis ? row.emr_order_code : row.assay_id
                            }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="hasUrinalysis ? 'COMMENTS' : 'CT Mean'"
                        prop="ct_mean"
                        width="100"
                      >
                        <template v-slot="{ row }">
                          <div class="patient-name">
                            {{ hasUrinalysis ? row.comments : row.ct_mean }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="
                          hasUrinalysis ? 'RESULT VALUE' : 'Reference Range'
                        "
                        prop="reference_range"
                        width="150"
                      >
                        <template v-slot="{ row }">
                          <div class="patient-name">
                            {{
                              hasUrinalysis
                                ? row.result_value
                                : row.reference_range
                            }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="hasUrinalysis ? 'UNITS' : 'Result'"
                        prop="result_nature"
                      >
                        <template v-slot="{ row }">
                          <div class="column-status">
                            <span class="el-dropdown-link">
                              <el-tag
                                v-if="row"
                                :type="getStatusType(row.result_nature)"
                              >
                                {{
                                  hasUrinalysis ? row.units : row.result_nature
                                }}
                              </el-tag>
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="hasUrinalysis ? 'REFERENCE RANGE' : 'Flags'"
                        prop="flags"
                      >
                        <template v-slot="{ row }">
                          {{
                            hasUrinalysis
                              ? row.lower_limit + "-" + row.upper_limit
                              : row.flags
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="hasUrinalysis ? 'FLAG' : 'ABR'"
                        prop="antibiotic_resistance"
                      >
                        <template v-slot="{ row }">
                          {{
                            hasUrinalysis ? row.flag : row.antibiotic_resistance
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="hasUrinalysis ? 'DILUTION' : 'Result Status'"
                        prop="result_status"
                      >
                        <template v-slot="{ row }">
                          {{ hasUrinalysis ? row.dilution : row.result_status }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-else class="no_Data">NO DATA</div>
                </div>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
      <div id="clinical-results-view-popup">
        <div class="default-modal">
          <el-dialog
            v-model="clinicalResultsPopup"
            width="70%"
            class="clinical-results-popup"
          >
            <div class="dialog-header">
              <span class="header-part"> Clinical Results </span>
              <el-button
                size="medium"
                class="el-white"
                type="info"
                plain
                @click="clinicalResultsPopup = false"
              >
                <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
              /></el-button>
            </div>
            <div class="all-cases-view">
              <div class="popup-date">
                <div class="primary-content-view-new" v-loading="loading">
                  <div
                    class="listings listings__table listings__all-cases"
                    id="all-cases-listings"
                    v-if="groupedResults.length > 0"
                  >
                    <div
                      v-for="(group, index) in groupedResults"
                      :key="index"
                      class="clinical_results_table"
                    >
                      <div class="category-header-row">
                        <h3 class="category-header">{{ group.category }}</h3>
                        <div class="testgo-map-field">
                          <label class="testgo-map-label">
                            Map TestGo Code
                            <span class="testgo-required-star">*</span>
                            <span
                              v-if="!group.testgo_order_code"
                              class="testgo-unmapped-badge"
                              >Not mapped</span
                            >
                          </label>
                          <el-select
                            v-model="group.testgo_order_code"
                            class="testgo-code-select"
                            :class="{ 'is-unmapped': !group.testgo_order_code }"
                            placeholder="Select TestGo Code"
                            size="small"
                            clearable
                            filterable
                            @change="onCategoryTestgoCodeChange(group)"
                          >
                            <el-option
                              v-for="code in testgoOrderCodeOptions"
                              :key="code"
                              :label="code"
                              :value="code"
                            />
                          </el-select>
                        </div>
                      </div>
                      <el-table :data="group.tests" height="200">
                        <el-table-column
                          label="Test Name"
                          prop="test_name"
                          width="250"
                        >
                          <template v-slot="{ row }">
                            <el-input
                              v-model="row.test_name"
                              placeholder="Enter Test Name"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Result"
                          prop="result"
                          width="150"
                        >
                          <template v-slot="{ row }">
                            <el-input
                              v-model="row.result"
                              placeholder="Enter Result"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column label="Units" prop="units" width="150">
                          <template v-slot="{ row }">
                            <el-input
                              v-model="row.units"
                              placeholder="Enter Units"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column label="Flags" prop="flag" width="100">
                          <template v-slot="{ row }">
                            <el-input
                              v-model="row.flag"
                              placeholder="Enter Flag"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Ref Range/Cutoff"
                          prop="ref_range"
                          width="210"
                        >
                          <template v-slot="{ row }">
                            <el-input
                              v-model="row.ref_range"
                              placeholder="Enter Range"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="TestGo Order Code"
                          prop="testgo_order_code"
                          min-width="220"
                        >
                          <template v-slot="{ row }">
                            <el-select
                              v-model="row.testgo_order_code"
                              class="testgo-code-select"
                              :class="{ 'is-unmapped': !row.testgo_order_code }"
                              placeholder="Select TestGo Code"
                              size="small"
                              clearable
                              filterable
                              @change="onRowTestgoCodeChange(group)"
                            >
                              <el-option
                                v-for="code in testgoOrderCodeOptions"
                                :key="code"
                                :label="code"
                                :value="code"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                  <div v-else class="no_Data">NO DATA</div>
                </div>
              </div>
            </div>
            <div class="dialog-footer export-footer w-95">
              <el-button
                class="blue-save-button"
                native-type="submit"
                @click="updateClinicalResults()"
                v-loading="updateLoading"
                >Update</el-button
              >
              <el-button
                class="blue-save-button"
                @click="updateAndSendToClientPortal()"
                v-loading="updateLoading"
                >Update &amp; Send to Client Portal</el-button
              >
            </div>
          </el-dialog>
        </div>
      </div>
      <div id="missing-test-results-popup">
        <div class="default-modal" v-if="resultMismatchedPopup">
          <el-dialog
            width="35%"
            v-model="resultMismatchedPopup"
            title="Missing Test Results"
          >
            <div class="dialog-header">
              <span class="header-part"> Missing Test Results </span>
              <el-button
                size="medium"
                class="el-white"
                type="info"
                @click="closeConfirmationPopup()"
              >
                <img
                  src="@/assets/images/icons/cases/close-btn.svg"
                  alt="icon"
                />
              </el-button>
            </div>
            <div class="popup-date missing-test-results">
              <div
                v-for="(tests, panelName) in groupedMissingTests"
                :key="panelName"
                class="panel-group"
              >
                <h4>{{ formatPanelName(panelName) }}</h4>
                <ol>
                  <li v-for="(testName, index) in tests" :key="index">
                    {{ testName }}
                  </li>
                </ol>
              </div>
              <p v-if="Object.keys(groupedMissingTests).length === 0">
                No missing test results found.
              </p>
            </div>
            <div class="dialog-footer">
              <el-button class="cancel-button" @click="closeConfirmationPopup()"
                >Cancel</el-button
              >
            </div>
          </el-dialog>
        </div>
      </div>
      <div id="missing-test-results-popup">
        <div class="default-modal" v-if="ismissmatchedResultsPopup">
          <el-dialog
            top="30vh"
            width="35%"
            v-model="ismissmatchedResultsPopup"
            title="Missing Test Results"
          >
            <div class="dialog-header">
              <span class="header-part">
                Mismatch Tests Between Report and Test Information</span
              >
              <el-button
                size="medium"
                class="el-white"
                type="info"
                @click="closeConfirmationPopup()"
              >
                <img
                  src="@/assets/images/icons/cases/close-btn.svg"
                  alt="icon"
                />
              </el-button>
            </div>
            <div class="popup-date missing-test-results">
              <h4
                style="
                  color: #000;
                  font-size: 14px;
                  font-weight: 500;
                  padding-bottom: 0.5rem;
                "
              >
                Missed Test Names
              </h4>
              <ol>
                <li
                  v-for="(testName, index) in DiscretemissingTests"
                  :key="index"
                >
                  {{ testName }}
                </li>
              </ol>
              <p v-if="discreteMissingTests?.length === 0">
                No missing test results found.
              </p>
            </div>
          </el-dialog>
        </div>
      </div>
      <div>
        <el-dialog
          width="30%"
          v-model="missedToxicologyPopup"
          title="Missing Toxicology Reports"
        >
          <div class="dialog-header">
            <span class="header-part"> Missing Toxicology Results </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              @click="closeMissedToxicologyDialog()"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
            </el-button>
          </div>
          <div class="popup-date missing-test-results">
            <ol>
              <li v-for="(test, index) in missedToxicologyTests" :key="index">
                {{ test }}
              </li>
            </ol>
          </div>
          <div class="dialog-footer">
            <el-button
              class="cancel-button"
              @click="closeMissedToxicologyDialog()"
              >Cancel</el-button
            >
          </div>
        </el-dialog>
      </div>
      <div id="discrete_results_view_popup">
        <div class="default-modal" v-if="discreteResultsPopupToxicology">
          <el-dialog
            width="69%"
            v-model="discreteResultsPopupToxicology"
            title="Discrete Results"
          >
            <div class="dialog-header">
              <span class="header-part"> Discrete Results </span>
              <el-button
                size="medium"
                @click="discreteResultsPopupToxicology = false"
                class="el-white"
                type="info"
              >
                <img
                  src="@/assets/images/icons/cases/close-btn.svg"
                  alt="icon"
                />
              </el-button>
            </div>
            <div class="all-cases-view">
              <div class="popup-date pb-0">
                <div
                  class="listings listings__table listings__all-cases"
                  id="all-cases-listings"
                  v-if="hasScreeingTests"
                >
                  <h3 class="primary-header">Screen Results</h3>
                  <el-table :data="screenResults" style="width: 100%">
                    <el-table-column
                      prop="Full Name"
                      label="Drug"
                      min-width="230"
                    >
                      <template #default="scope">
                        <div class="dark-blue-color">
                          {{ scope.row.test_name }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="result"
                      label="Result"
                      min-width="180"
                    >
                      <template #default="scope">
                        <div class="pr-20">
                          {{ scope.row.result }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="resultValue"
                      label="Results Value"
                      min-width="180"
                    >
                      <template #default="scope">
                        <div class="pr-20">
                          {{ scope.row.result_value }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="cutOff" label="Cut Off" width="200">
                      <template #default="scope">
                        <span
                          v-if="
                            (scope.row.high_limit || scope.row.low_limit) &&
                            (scope.row.report_test_name === 'pH' ||
                              scope.row.report_test_name === 'OXIDANTS')
                          "
                          >{{
                            parseFloat(scope.row.low_limit) +
                            "-" +
                            parseFloat(scope.row.high_limit)
                          }}</span
                        >
                        <span v-else-if="scope.row.cutoff">{{
                          scope.row.cutoff +
                          " " +
                          (scope.row.report_test_name != "URINE CREATININE"
                            ? scope.row.Units
                            : "")
                        }}</span>
                        <span v-else>--</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-if="hasConfirmationTests">
                <div class="popup-date pb-0">
                  <h2 class="dark-blue-color" v-if="hasConfirmationTests">
                    <span>
                      <img
                        src="@/assets/images/icons/confirmation-tests.svg"
                        alt="icon"
                      />
                    </span>
                    CONFIRMATION TESTS
                  </h2>
                </div>
                <div v-for="(test, index) of categoryCodes" :key="index">
                  <div class="popup-date pb-0">
                    <h3 class="primary-header">
                      {{ test.name }}
                    </h3>

                    <div
                      class="listings listings__table listings__all-cases"
                      id="all-cases-listings"
                    >
                      <el-table :data="test.results" style="width: 100%">
                        <el-table-column
                          prop="report_test_name"
                          label="Test Screen"
                          min-width="200"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="testOutcome"
                          label="Test Outcome"
                          min-width="150"
                        >
                          <template #default="scope">
                            <div class="date-type-checkbox">
                              {{ scope.row.flag }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="result"
                          label="Measured Results"
                          min-width="150"
                        >
                          <template #default="scope">
                            {{ scope.row.result }}
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="determination"
                          label="Determination"
                          width="120"
                        >
                          <template #default="scope">
                            <div class="date-type-checkbox">
                              {{ scope.row.interpretation }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="cutoff"
                          align="center"
                          label="Cut Off"
                          width="100"
                        >
                          <template #default="scope">
                            <span v-if="scope.row.cutoff">{{
                              scope.row.cutoff +
                              " " +
                              (scope.row.Units || scope.row.Unit)
                            }}</span>
                            <span v-else>--</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          label="Range"
                          width="150"
                        >
                          <template #default="scope">
                            <span>{{
                              scope.row.LLMI +
                              "-" +
                              scope.row.ULMI +
                              " " +
                              (scope.row.Units || scope.row.Unit)
                            }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="no_Data">NO DATA</div>
            </div>
          </el-dialog>
        </div>
      </div>
      <SendoutRemovePopup
        v-model="showSendoutRemovePopup"
        @confirm="onConfirmSendoutRemove"
      />
      <div class="default-modal">
        <el-dialog
          v-model="showNotesDialog"
          width="45%"
          :before-close="closeNotesDialog"
          v-loading="noteSubmitLoading"
        >
          <div class="dialog-header">
            <span class="header-part">REPORT NOTES</span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="closeNotesDialog"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
            </el-button>
          </div>
          <div class="popup-date pb-0">
            <!-- Quick-pick predefined labels -->
            <p style="font-weight: 600; font-size: 12px; color: #273480; margin: 0 0 8px;">Quick Pick</p>
            <div style="display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 14px;">
              <el-button
                v-for="opt in notePredefinedOptions"
                :key="opt.label"
                size="small"
                class="cancel-button"
                @click="applyNotePredefined(opt)"
                style="font-size: 12px;"
              >{{ opt.label }}</el-button>
            </div>
            <div class="popup-el-select" style="margin-bottom: 10px;">
              <label style="font-size: 12px; font-weight: 500;">Title*</label>
              <el-input
                v-model="noteForm.title"
                placeholder="Enter note title"
                size="small"
              />
            </div>
            <div class="popup-el-select">
              <label style="font-size: 12px; font-weight: 500;">Description*</label>
              <el-input
                v-model="noteForm.description"
                type="textarea"
                :rows="3"
                placeholder="Enter note description"
              />
            </div>
            <div class="dialog-footer" style="margin-top: 12px;">
              <el-button class="cancel-button" @click="closeNotesDialog">Cancel</el-button>
              <el-button
                class="blue-save-button"
                :loading="noteSubmitLoading"
                @click="submitNote"
              >Add Note</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
      <div class="default-modal">
        <el-dialog
          v-model="showPhysicianAcknowledgeDialog"
          width="42%"
          :before-close="onPhysicianAcknowledgeCancel"
        >
          <div class="dialog-header">
            <span class="header-part">MARK FOR PHYSICIAN</span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="onPhysicianAcknowledgeCancel"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
            </el-button>
          </div>
          <div class="popup-date pb-0">
            <p style="font-size: 13px; color: #444; margin: 0 0 12px;">
              Please review the notes below before marking this report for the physician.
            </p>
            <!-- Notes for this report -->
            <div
              v-if="getCaseInformation && getCaseInformation.report_notes && getCaseInformation.report_notes.length"
              class="notes-list"
              style="max-height: 260px; overflow-y: auto; margin-bottom: 12px;"
            >
              <div
                v-for="(note, idx) in getCaseInformation.report_notes"
                :key="idx"
                class="note-item"
                style="border: 1px solid #e0e0e0; border-radius: 4px; padding: 10px 12px; margin-bottom: 8px; background: #f9f9f9;"
              >
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px;">
                  <strong style="font-size: 13px; color: #273480;">{{ note.title }}</strong>
                  <span style="font-size: 11px; color: #888;">
                    {{ note.added_by_name }} &bull; {{ formatNoteDate(note.added_at) }}
                  </span>
                </div>
                <p style="margin: 0; font-size: 13px; color: #444;">{{ note.description }}</p>
              </div>
            </div>
            <div class="dialog-footer">
              <el-button class="cancel-button" @click="onPhysicianAcknowledgeCancel">Cancel</el-button>
              <el-button class="blue-save-button" @click="onPhysicianAcknowledge">Acknowledge & Mark</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";

import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
const UploadTestReports = defineAsyncComponent(() =>
  import("@/components/cases/UploadTestReports")
);
const SendoutRemovePopup = defineAsyncComponent(() =>
  import("@/components/cases/SendoutRemovePopup.vue")
);
import AppHelper from "@/mixins/AppHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import moment from "moment";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import draggable from "vuedraggable";
import { ElMessageBox } from "element-plus";
import axios from "axios";
export default {
  props: ["caseIdProp", "displayUploading", "caseData", "patientResults"],
  data() {
    return {
      skipFetchTestPanels: true,
      buttonLoading: false,
      form: {
        additional_reports: [],
      },
      additionalReportsPopup: false,
      files: [],
      reportId: "",
      activeName: "uploadFiles",

      caseId: "",
      caseTypes: [],
      patientData: {},
      selectedReportTitle: "",
      showTestReport: false,
      testReportURL: "",
      loading: false,
      validatingResultId: null,
      viewReportLoadingId: null,
      patientSectionClear: false,
      testReports: [],
      selectedReportForEditTitle: {},
      loadingText: "Fetching Reports...",

      selectedReportForEditNote: {},
      selectedReportNote: "",
      caseStatus: "",
      editBlockReason: "",
      sent_fax: "",
      takeReasonDialog: false,
      autoSendToEmr: false,
      autoFax: false,
      autoEmail: false,
      reportFinalize: {},

      // emr options
      askEmrConfig: false,
      selectedReport: null,
      resultStatusOptions: [
        {
          label: "Completed",
          value: "COMPLETED",
        },
        {
          label: "Corrected",
          value: "CORRECTED",
        },
      ],
      emrNotes: "",
      emrResultStatus: "COMPLETED",

      // Fax options
      sendReportToEMR: true,
      sendReportToFax: true,

      // resend fax options
      selectedFaxReport: null,
      askResendFaxConfigOptions: false,
      resendFaxConfig: {
        hospital: true,
        referring_physician: true,
        additional_fax_numbers: [],
      },
      faxOptions: [],
      hospitalInfo: {},
      discreteResultsData: [],
      discreteData: [],
      discreteResultsPopup: false,
      clinicalResultsPopup: false,
      clinicalResultsData: [],
      groupedResults: [],
      updateLoading: false,
      reportPdfId: "",
      bloodResults: [],
      testInformation: {},
      filteredNullResults: [],
      resultMismatchedPopup: false,
      filteredResults: [],
      discreteResultsPopupToxicology: false,
      screenResults: [],
      confirmationResults: [],
      categoryCodes: [],
      hasScreeingTests: false,
      hasConfirmationTests: false,
      DiscretemissingTests: [],
      ismissmatchedResultsPopup: false,
      urineTestResults: [],
      missedToxicologyTests: [],
      missedToxicologyPopup: false,
      // sendout remove popup
      showSendoutRemovePopup: false,
      pendingPhysicianToggle: { status: false, report: null },
      // report notes
      showNotesDialog: false,
      showPhysicianAcknowledgeDialog: false,
      pendingPhysicianMarkReport: null,
      noteForm: {
        title: "",
        description: "",
      },
      notePredefinedOptions: [
        {
          label: "Rerun",
          description:
            "This report requires a rerun due to inconclusive or inconsistent results.",
        },
        {
          label: "Pending Review",
          description:
            "This report is currently under review and the final results will be Confirmed shortly.",
        },
      ],
      noteSubmitLoading: false,
    };
  },
  async mounted() {
    this.caseId = this.$route.params.case_id || this.caseIdProp;
    this.$store.dispatch("cases/checkCaseFaxStatus", this.caseId);
    this.$store.commit("errors/clear", null, { root: true }); // sync mutation, no await needed
    // fetchSingleHospital doesn't depend on checkCaseInformation — run in parallel
    await Promise.all([
      this.checkCaseInformation(),
      this.fetchSingleHospital(this.hospitalId),
    ]);
  },
  mixins: [UserPermissionsHelper, AppHelper, caseDataHelper],
  components: {
    UploadTestReports,
    draggable,
    SendoutRemovePopup,
  },
  computed: {
    ...mapGetters("respiratoryFileUpload", [
      "getCovidStatusUpdated",
      "getCovidStatusUpdateError",
    ]),
    ...mapGetters("resultFiles", [
      "getDiscreteResultSendStatus",
      "getDiscreteResultsDetails",
      "getRemoveDiscreteResultsStatus",
      "getDiscreteResultsMismatchedTests",
    ]),
    blockMarkForPhysician() {
      if (
        !this.getCaseInformation ||
        !this.getCaseInformation.is_cross_lab_registered
      ) {
        return false;
      }
      const sampleRunLocation = this.getCaseInformation.sample_run_location;
      return !!(
        (sampleRunLocation === "Irving" && this.isIrvingLab) ||
        (sampleRunLocation === "Houston" && this.isHoustonLab)
      );
    },
    hasToxicology() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.indexOf("TOXICOLOGY") > -1
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    isLabAssistant() {
      const labAssistantTypes = [
        "LAB_DATA_ASSISTANT",
        "LAB_DATA_ADMIN",
        "BILLING_REPRESENTATIVE",
        "AR_LEAD",
        "AR_EXECUTIVE",
        "CP_LEAD",
        "CODING_LEAD",
        "CODING_EXECUTIVE",
        "POSTING_EXECUTIVE",
        "SR_FTE",
      ];

      if (
        this.getAuthenticatedUser &&
        labAssistantTypes.includes(this.getAuthenticatedUser.user_type)
      ) {
        return true;
      }
      return false;
    },
    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else if (status == "INCONSISTENT") {
          return "warning";
        } else if (status == "CONSISTENT") {
          return "success";
        } else {
          return "";
        }
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "NEGATIVE") {
          return "success";
        } else if (status == "POSITIVE") {
          return "danger";
        } else {
          return "default";
        }
      };
    },
    hasAdditionalReports() {
      if (this.files && this.files.length) {
        return false;
      }
      return true;
    },
    ...mapGetters("cases", [
      "getCaseInformation",
      "getPrilimenaryReportGenerating",
      "getReportGenerateStatus",
      "getTestReportURL",
      "getReportDeleteStatus",
      "getReportPhysicianStatusUpdated",
      "getReportPhysicianStatusData",
      "getTestReportsData",
      "getTestReportNoteAdded",
      "getReportTitleUpdated",
      "getMergeCaseReportStatus",
      "getDownloadReportData",
      "getReportNoteUpdated",
      "getFaxSentStatus",
      "getCheckFaxStatus",
      "getReportSentToPatientBySMSStatus",
      "getReportSentToPatientStatus",
      "getAdditionalReports",
      "getMultipleReportsUploadData",
      "getAttachmentUploadStatus",
      "getMergeAddtionalReports",
      "getTestReportsDownloadLog",
      "getTestReportsViewLog",
      "getPhysicianValidations",
      "getUtiCaseCreationStatus",
      "getCCCaseCreationStatus",
      "getUrineCultureCaseCreationStatus",
      "getGenerateReportForClinicalChemistryStatus",
      "getClinicalChemistryReportDataById",
      "getUpdateClinicalResultsStatusById",
      "getSendClinicalResultsToPortalStatus",
      "getAllTestResults",
      "getSingleCaseTestsInfo",
      "getReportReleaseStatusData",
      "getGenerateDiscreteForSendoutStatus",
      "getsyncDiscreteReports",
      "getUrineTestResults",
      "getUrineMachineResults",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("respiratoryFileUpload", ["getFileDownloadUrl"]),
    ...mapGetters("emrOrders", [
      "getSendReportStatus",
      "getEmrUniBiDirectionalStatus",
      "getSendAthenaEMRDiscreteResultsStatus",
    ]),
    ...mapGetters("errors", ["getError", "getErrors"]),
    ...mapGetters("profile", ["getUserLabSettings"]),
    ...mapGetters("hospitals", ["getSingleHospital"]),
    testgoOrderCodeOptions() {
      return (
        this.getCaseInformation?.testgo_order_codes ||
        this.caseData?.testgo_order_codes ||
        []
      );
    },
    isEligibleToSendFax() {
      return (
        this.getCheckFaxStatus &&
        this.getCheckFaxStatus.lab_fax_status &&
        (this.getCheckFaxStatus.hospital_fax_status ||
          this.getCheckFaxStatus.referring_physician_fax_status ||
          this.getCheckFaxStatus.additional_fax_status)
      );
    },
    hospitalId() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.hospital &&
        this.getCaseInformation.hospital._id
      ) {
        return this.getCaseInformation.hospital._id;
      }
      return null;
    },
    checkNewReport() {
      return (report) => {
        if (report && report.download_logs && report.download_logs.length) {
          if (this.getAuthenticatedUser && this.getAuthenticatedUser._id) {
            let userView = report.download_logs.find(
              (e) => e.user_id === this.getAuthenticatedUser._id
            );
            if (userView) {
              return true;
            } else {
              return false;
            }
          }
        }
      };
    },
    isCaseFinalized() {
      return (report) => {
        if (
          report &&
          report.mark_for_physician &&
          report.mark_for_physician == true
        ) {
          return true;
        } else {
          return false;
        }
      };
    },
    isCaseComplete() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.status &&
        this.getCaseInformation.status === "COMPLETE"
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasPGXCase() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.case_types &&
        this.getCaseInformation.case_types.length &&
        this.getCaseInformation.case_types.indexOf("PGX_TEST") > -1
      ) {
        return true;
      }
      return false;
    },
    statuses() {
      return Array.isArray(this.$route.query.status)
        ? this.$route.query.status
        : [this.$route.query.status];
    },
    groupedMissingTests() {
      const grouped = {};
      this.filteredNullResults.forEach((item) => {
        const panelName = item.panel_code; // Or whatever you want to call the group key
        if (!grouped[panelName]) {
          grouped[panelName] = [];
        }
        grouped[panelName].push(item.test_name);
      });
      // You can also sort the panel names if you wish
      const sortedPanelNames = Object.keys(grouped).sort();
      const sortedGrouped = {};
      sortedPanelNames.forEach((panel) => {
        sortedGrouped[panel] = grouped[panel].sort(); // Optionally sort tests within each panel
      });
      return sortedGrouped;
    },
    isSendoutCategory() {
      if (this.getSingleCaseTestsInfo) {
        return this.getSingleCaseTestsInfo.every(
          (e) => e.panel_code !== "SEND_OUTS"
        );
      }
      return false;
    },
    hasUrinalysis() {
      return (
        this.getCaseInformation &&
        this.getCaseInformation.case_types[0] == "URINALYSIS"
      );
    },
  },
  watch: {
    caseIdProp() {
      this.caseId = this.caseIdProp;
      this.checkCaseInformation();
    },
  },
  methods: {
    async addAdditionalReport(report, skipDownload = true) {
      if (report.download_ready == false) {
        await this.$store.dispatch("cases/generateTestReport", {
          accession_id: this.getCaseInformation.accession_id,
          case_type: report.case_type,
          report_id: report.report_id,
          test_results_id: report.test_results_id,
          result_file_id: report.result_file_id,
          skip_download: skipDownload,
        });
      }

      this.additionalReportsPopup = true;
      this.reportId = report._id;
    },
    // Sendout remove popup handlers
    async onConfirmSendoutRemove(shouldDelete) {
      this.showSendoutRemovePopup = false;
      const { status, report } = this.pendingPhysicianToggle || {};
      this.pendingPhysicianToggle = { status: false, report: null };
      if (!report) return;
      await this.finaliseReport(status, report);
    },
    async generateDiscreteResultsForAdvanta(report) {
      try {
        this.loading = true;
        let labName = null;
        if (
          this.getCaseInformation &&
          this.getCaseInformation.sendout &&
          this.getCaseInformation.sendout.received_lab &&
          this.getCaseInformation.sendout.received_lab.name
        ) {
          labName = this.getCaseInformation.sendout.received_lab.name;
        }
        let params = {
          case_id: this.getCaseInformation._id,
          report_id: report._id,
          sendout_lab: labName,
          case_types: this.getCaseInformation.case_types[0],
        };
        await this.$store.dispatch(
          "cases/generateDiscreteResultsAdvanta",
          params
        );
        if (this.getGenerateDiscreteForSendoutStatus) {
          successNotification("Discrete Results generated successfully");
          await this.checkCaseInformation();
        } else {
          errorNotification("Error while generating discrete results");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async syncDiscreteResults(report) {
      try {
        this.loading = true;
        let params = {
          case_id: this.caseId,
          test_report_id: report._id,
        };
        await this.$store.dispatch("cases/syncDiscreteReports", params);
        if (this.getsyncDiscreteReports) {
          successNotification("Discrete Results synced successfully");
          this.checkCaseInformation();
        } else {
          errorNotification(
            this.getError || "Error while syncing discrete results"
          );
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    getCategoryCodeData(category, data) {
      return data
        .filter((result) => {
          if (result.category == category) {
            return result;
          }
        })
        .sort((a, b) => a.report_test_name.localeCompare(b.report_test_name));
    },
    async viewDiscreteResultsToxicology(disctete) {
      let params = {
        discrete_id: disctete,
      };
      await this.$store.dispatch("resultFiles/fetchDiscreteResults", params);
      if (
        this.getDiscreteResultsDetails &&
        this.getDiscreteResultsDetails.discrete_results
      ) {
        this.screenResults =
          this.getDiscreteResultsDetails.discrete_results.screen_results || [];
        this.confirmationResults =
          this.getDiscreteResultsDetails.discrete_results
            .confirmation_results || [];
        this.confirmationResults = this.confirmationResults.sort(function (
          a,
          b
        ) {
          return ("" + a.category_code).localeCompare(b.category_code);
        });
        this.screenResults = this.screenResults.sort(function (a, b) {
          return ("" + a.report_test_name).localeCompare(b.report_test_name);
        });
        this.hasScreeingTests = this.screenResults.length ? true : false;
        this.hasConfirmationTests = this.confirmationResults.length
          ? true
          : false;
        this.categoryCodes = this.confirmationResults.map(
          (result) => result.category
        );
        this.categoryCodes = [...new Set(this.categoryCodes)];
        this.categoryCodes = this.categoryCodes.map((categoryCode) => {
          return {
            name: categoryCode,
            results: this.getCategoryCodeData(
              categoryCode,
              this.confirmationResults
            ),
          };
        });
        this.discreteResultsPopupToxicology = true;
      }
    },
    async generateDiscreteForClinicalChemistry(report) {
      try {
        this.loading = true;
        let labName = null;
        if (
          this.getCaseInformation &&
          this.getCaseInformation.sendout &&
          this.getCaseInformation.sendout.received_lab &&
          this.getCaseInformation.sendout.received_lab.name
        ) {
          labName = this.getCaseInformation.sendout.received_lab.name;
        }
        let params = {
          case_id: this.$route.params.case_id,
          report_id: report._id,
          sendout_lab: labName,
          case_types: this.getCaseInformation.case_types[0],
        };
        await this.$store.dispatch(
          "cases/generateDiscreteSendoutReports",
          params
        );
        if (this.getGenerateDiscreteForSendoutStatus) {
          successNotification("Discrete results generated for the report");
          await this.checkCaseInformation();
        } else {
          errorNotification(
            this.getError ||
              "Error while generating discrete results for the report"
          );
        }
        this.loading = false;
      } catch (err) {
        console.log("err: ", err);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    closeConfirmationPopup() {
      this.resultMismatchedPopup = false;
      this.ismissmatchedResultsPopup = false;
    },
    async updateClinicalResults() {
      try {
        this.updateLoading = true;
        let updatedResults = this.groupedResults.reduce((acc, group) => {
          return acc.concat(group.tests);
        }, []);
        let params = {
          report_pdf_id: this.reportPdfId,
          results: updatedResults,
        };
        await this.$store.dispatch(
          "cases/updateClinicalChemistryResults",
          params
        );
        if (this.getUpdateClinicalResultsStatusById) {
          successNotification("Discrete results updated successfully");
          this.clinicalResultsPopup = false;
          await this.checkCaseInformation();
        } else {
          errorNotification("Error while updating discrete results");
        }
        this.updateLoading = false;
      } catch (err) {
        this.updateLoading = false;
        console.log(err);
      } finally {
        this.updateLoading = false;
      }
    },
    groupResultsByCategory() {
      // Group the clinicalResultsData by 'category'
      const grouped = this.clinicalResultsData.reduce((acc, test) => {
        const category = test.category;
        if (!acc[category]) {
          acc[category] = { category: category, tests: [] };
        }
        acc[category].tests.push(test);
        return acc;
      }, {});

      Object.values(grouped).forEach((group) => {
        group.tests.sort((a, b) => a.result_order - b.result_order);
        // Category-level dropdown reflects the rows only when they all share one code
        this.syncCategoryTestgoCode(group);
      });

      // Convert grouped object to array for easier rendering
      this.groupedResults = Object.values(grouped);
    },
    onCategoryTestgoCodeChange(group) {
      // Category-level selection applies to every test row in the category (bulk map)
      group.tests.forEach((test) => {
        test.testgo_order_code = group.testgo_order_code || "";
      });
    },
    onRowTestgoCodeChange(group) {
      // Individual row override — keep the category dropdown in sync (blank if mixed)
      this.syncCategoryTestgoCode(group);
    },
    syncCategoryTestgoCode(group) {
      const codes = group.tests.map((t) => t.testgo_order_code || "");
      const allSame = codes.every((c) => c && c === codes[0]);
      group.testgo_order_code = allSame ? codes[0] : "";
    },
    async updateAndSendToClientPortal() {
      try {
        // TestGo code mapping is required on every result before sending to the portal
        const unmapped = this.groupedResults.filter((group) =>
          group.tests.some((t) => !t.testgo_order_code)
        );
        if (unmapped.length) {
          errorNotification(
            `Map a TestGo code for: ${unmapped
              .map((g) => g.category)
              .join(", ")}`
          );
          return;
        }
        this.updateLoading = true;
        let updatedResults = this.groupedResults.reduce((acc, group) => {
          return acc.concat(group.tests);
        }, []);
        await this.$store.dispatch("cases/updateClinicalChemistryResults", {
          report_pdf_id: this.reportPdfId,
          results: updatedResults,
        });
        if (!this.getUpdateClinicalResultsStatusById) {
          errorNotification("Error while updating discrete results");
          return;
        }
        await this.$store.dispatch(
          "cases/sendClinicalChemistryReportToClientPortal",
          { report_pdf_id: this.reportPdfId }
        );
        if (this.getSendClinicalResultsToPortalStatus) {
          successNotification(
            "Discrete results updated and report queued to send to client portal"
          );
          this.clinicalResultsPopup = false;
          await this.checkCaseInformation();
        } else {
          errorNotification(
            "Results updated, but failed to queue report for client portal"
          );
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.updateLoading = false;
      }
    },
    async genClinicalChemistryReportResults(report) {
      try {
        this.loading = true;
        let params = {
          report_pdf_id: report,
        };
        await this.$store.dispatch(
          "cases/getClinicalChemistryResultsDataById",
          params
        );
        if (
          this.getClinicalChemistryReportDataById &&
          this.getClinicalChemistryReportDataById.results &&
          this.getClinicalChemistryReportDataById.results.length
        ) {
          this.clinicalResultsData =
            this.getClinicalChemistryReportDataById.results || [];
          this.groupResultsByCategory();
          this.reportPdfId = report;
          this.clinicalResultsPopup = true;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async resendEmr(emr) {
      try {
        this.loading = true;
        let params = {
          order_id: this.getCaseInformation.emr_order,
          notes: [""],
          emr_result_status: "COMPLETED",
        };
        params.finalized_report_ids = [emr._id];
        params.test_report_ids = [emr._id];

        if (
          this.getCaseInformation &&
          this.getCaseInformation.emr_order_type == "UNIDIRECTIONAL"
        ) {
          params.order_type = this.getCaseInformation.emr_order_type;
          params.case_id = this.getCaseInformation._id;
        }
        await this.$store.dispatch("emrOrders/sendReportToEmr", params);
        this.loading = false;

        if (
          this.getSendReportStatus ||
          this.getEmrUniBiDirectionalStatus ||
          this.getSendAthenaEMRDiscreteResultsStatus
        ) {
          successNotification("Report(s) ReSent Successfully");
          window.location.reload();
        } else {
          errorNotification("Error while resending report");
        }
      } catch (err) {
        console.log(err);
      }
    },
    async removeDiscreteResults(disctete) {
      try {
        this.loading = true;
        let params = {
          discrete_id: disctete,
        };
        await this.$store.dispatch("resultFiles/removeDiscreteResults", params);
        if (this.getRemoveDiscreteResultsStatus) {
          successNotification("Discrete results removed successfully");
          await this.checkCaseInformation();
        } else {
          errorNotification("Error while removing discrete results");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async viewDiscreteResults(disctete) {
      let params = {
        discrete_id: disctete,
      };
      await this.$store.dispatch("resultFiles/fetchDiscreteResults", params);
      if (
        this.getDiscreteResultsDetails &&
        this.getDiscreteResultsDetails.discrete_results &&
        this.getDiscreteResultsDetails.discrete_results.length
      ) {
        this.discreteData = this.getDiscreteResultsDetails.discrete_results;
        this.discreteResultsPopup = true;
      }
    },
    handleUpload(file, rowData) {
      const reader = new FileReader();

      // Define the keys you want to extract from the CSV
      const keysToExtract = [
        "display_name",
        "long_name",
        "ct_mean",
        "reference_range",
        "result",
        "antibiotic_resistance",
        "level",
      ];

      reader.onload = (event) => {
        const csvData = event.target.result;
        const rows = csvData.split("\n");

        // Initialize an array to store objects containing extracted keys
        const extractedData = [];

        // Process each row of CSV data, starting from the second row (index 1)
        for (let i = 1; i < rows.length; i++) {
          const row = rows[i];
          const values = row.split(",");

          // Check if the row has enough values to match the keys to extract
          if (values.length >= keysToExtract.length) {
            // Create an object with the desired keys and corresponding values
            const dataObject = {};

            keysToExtract.forEach((key, index) => {
              // Trim each value to remove leading/trailing spaces
              const value = values[index] ? values[index].trim() : "";
              dataObject[key] = value;
            });

            // Check if the data object contains at least one non-empty value
            const hasValidData = Object.values(dataObject).some(
              (value) => value !== ""
            );

            if (hasValidData) {
              extractedData.push(dataObject); // Add the object to the extractedData array
            } else {
              console.warn(
                `Skipping row ${i + 1} with insufficient data: ${row}`
              );
            }
          } else {
            console.warn(
              `Skipping row ${i + 1} with insufficient data: ${row}`
            );
          }
        }

        // Check if extractedData array is empty after filtering
        if (extractedData.length === 0) {
          // Display an error notification if no valid rows were extracted
          errorNotification("Uploaded file does not contain any valid results");
          return; // Stop further processing
        }

        if (extractedData.length > 0) {
          extractedData.shift(); // Remove the first object
        }
        // Map extractedData to discreResults objects and push to discreteResultsData array
        const discreteResultsData = extractedData.map((results) => ({
          display_name: results.display_name
            ? results.display_name.replace(/"/g, "")
            : "",
          assay_id: results.long_name
            ? results.long_name.replace(/"/g, "")
            : "",
          ct_mean: parseFloat(results.ct_mean) || 0,
          result_nature: results.result ? results.result.replace(/"/g, "") : "",
          flags: results.level ? results.level.replace(/"/g, "") : "",
          reference_range: results.reference_range
            ? results.reference_range.replace(/"/g, "")
            : "",
          antibiotic_resistance: results.antibiotic_resistance
            ? results.antibiotic_resistance.replace(/"/g, "")
            : "",
          result_status: "F", // Set result_status to "F"
        }));

        this.discreteResultsData.push(...discreteResultsData);
        // Call sendDiscreteResults with rowData
        this.sendDiscreteResults(rowData);
      };

      // Read the uploaded CSV file as text
      reader.readAsText(file.raw);
    },
    async sendDiscreteResults(report_id) {
      try {
        this.loading = true;
        let params = {
          case_id: this.getCaseInformation._id,
          test_report_id: report_id._id,
          discrete_results: this.discreteResultsData,
        };
        await this.$store.dispatch("resultFiles/addDiscreteResults", params);
        if (this.getDiscreteResultSendStatus) {
          successNotification("Discrete results uploaded successfully");
          await this.checkCaseInformation();
        } else {
          errorNotification("Error while uploading discrete results");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    prepareParams(data) {
      let params = {
        result_file_id: data.result_file_id,
        sample_name_id: data.report_id,
        test_result_id: data.test_results_id,
        sample_name: this.getCaseInformation.accession_id,
      };

      if (data.covid_status) {
        params.covid_status = data.covid_status;
      }
      params.report_status = [];

      return params;
    },
    async finalizeReport(data) {
      this.loading = true;
      this.selectedFinalizedReport = null;
      let params = this.prepareParams(data);
      this.finalizedAccession = this.getCaseInformation.accession_id;
      await this.$store.dispatch(
        "respiratoryFileUpload/updateCovidStatus",
        params
      );
      
      if (this.getCovidStatusUpdated && this.getCovidStatusUpdated.success) {
        successNotification("Test Report Finalized!");
        await this.checkCaseInformation();
        this.loading = false;
      } else {
        this.loading = false;
        errorNotification(
          this.getError ||
            this.getCovidStatusUpdateError ||
            "Status Not Updated"
        );
        await this.checkCaseInformation();
      }
    },
    async generateReportWhileFinalizing(report) {
      try {
        await this.$store.dispatch("cases/generateTestReport", {
          case_id: this.getCaseInformation.accession_id,
          accession_id: this.getCaseInformation.accession_id,
          case_type: report.case_type,
          report_id: report.report_id,
          test_results_id: report.test_results_id,
          result_file_id: report.result_file_id,
          skip_download: true,
        });
      } catch (err) {
        console.log(err);
      }
    },
    async testReportsDownloadLog(report) {
      let params = {
        case_id: this.$route.params.case_id || this.caseIdProp,
        report_id: report._id,
      };
      await this.$store.dispatch("cases/testReportsDownloadLog", params);
    },
    async testReportsViewLog(report) {
      let params = {
        case_id: this.$route.params.case_id || this.caseIdProp,
        report_id: report._id,
      };
      await this.$store.dispatch("cases/testReportsViewLog", params);
    },
    async fetchSingleHospital(hospitalId) {
      await this.$store.dispatch("hospitals/fetchSingleHospital", hospitalId);
      if (
        this.getSingleHospital &&
        this.getSingleHospital.settings &&
        this.getSingleHospital.settings.patient_report_settings
      ) {
        this.hospitalInfo = JSON.parse(
          JSON.stringify(
            this.getSingleHospital.settings.patient_report_settings
          )
        );
      }
    },
    remove(index) {
      this.files.splice(index, 1);
    },
    move(from, to) {
      this.files.move(from, to);
      this.form.title = this.files[0].name;
    },
    async sendAdditionalReports() {
      try {
        this.buttonLoading = true;
        this.loading = true;

        await this.prepareMultipleReportsData();
        let params = this.prepareMultipleReportsFormData();
        params.report_id = this.reportId;
        params.additional_reports_merged = false;
        await this.$store.dispatch(
          "cases/updateTestReportAdditionalReports",
          params
        );
        if (this.getAdditionalReports) {
          successNotification("Additional Reports Uploaded Successfully");
          window.location.reload();
        } else {
          errorNotification("Error in Uploading Additional Report");
        }
        this.files = [];
        this.additionalReportsPopup = false;
        this.buttonLoading = false;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    prepareMultipleReportsFormData() {
      let reportsData = [];
      for (let i = 0; i < this.files.length; i++) {
        reportsData.push({
          report_source: this.files[i].report_path,
          report_title: this.files[i].name,
          order: i + 1,
          download_ready: true,
        });
      }
      let params = {
        case_id: this.$route.params.case_id || this.caseIdProp,
        additional_reports: reportsData,
      };
      return params;
    },
    prepareParamsForFileCreate(file) {
      return {
        file: file.raw.name,
        file_type: file.raw.type,
        file_size: file.raw.size / 1000,
        case_id: this.$route.params.case_id,
        type: this.form.case_type,
      };
    },
    async prepareMultipleReportsData() {
      for (let fileIndex = 0; fileIndex < this.files.length; fileIndex++) {
        this.files[fileIndex].percentage = 0;
        let data = this.prepareParamsForFileCreate(this.files[fileIndex].file);
        await this.$store.dispatch("cases/fetchFileUploadUrl", data);
        if (
          this.getMultipleReportsUploadData &&
          this.getMultipleReportsUploadData.target_url
        ) {
          this.files[fileIndex].percentage = 30;
          this.files[fileIndex].report_path =
            this.getMultipleReportsUploadData.path || "";

          let params = {
            file: this.files[fileIndex].file.raw,
            upload_url: this.getMultipleReportsUploadData.target_url,
          };
          await this.$store.dispatch(
            "cases/uploadDocumentToGeneratedUrl",
            params
          );
          if (this.getAttachmentUploadStatus) {
            this.files[fileIndex].percentage = 70;

            let params = {
              case_id: this.$route.params.case_id,
              ref_id: this.getMultipleReportsUploadData.hash,
            };
            await this.$store.dispatch("cases/updateTestReportStatus", params);
            this.files[fileIndex].percentage = 100;
            this.files[fileIndex].status = true;
          }
        }
      }
    },
    handleReportRemove() {
      this.files = [];
    },
    async handleMultipleFileUpload(file) {
      if (this.beforeAvatarUpload(file)) {
        const fileData = {
          file: file,
          name: file.name,
          error_message: null,
          percentage: 0,
          success: false,
          report_path: "",
        };

        this.files.push(fileData);
      }
    },
    beforeAvatarUpload(file) {
      // checking file size less than 100mb
      const checkSize = file.size / Math.pow(1024, 100) < 1;
      if (!checkSize) {
        this.$message.error("File size can not exceed 100MB!");
      }
      return checkSize;
    },
    updateSelectedTabQuery() {
      this.$router.push({
        query: {
          ...this.$route.query,
          selectedCaseId: this.caseIdProp,
          selected_panel:
            this.activeName == "uploadFiles"
              ? "uploadFiles"
              : this.caseTypes[this.activeName].case_type,
        },
      });
    },
    async onGenerate(report) {
      try {
        this.loading = true;
        this.loadingText = "Merging report...";
        let params = {
          case_id: this.$route.params.case_id || this.caseIdProp,
          report_id: report._id,
        };
        await this.$store.dispatch("cases/mergeCaseReport", params);
        if (this.getMergeCaseReportStatus) {
          successNotification("Report Merged Successfully");
          await this.checkCaseInformation();
        } else {
          errorNotification("Error in Merging Report");
        }
        this.loading = false;
        this.loadingText = "";
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    onViewResultFile(report) {
      let routerData = this.$router.resolve({
        name: "viewprogress",
        params: {
          result_file_id: report.result_file_id,
        },
        query: {
          ...this.$route.query,
          case_id: this.caseId,
          redirectRoute: this.$route.name,
        },
      });
      window.location.href = routerData.href;
    },
    onReportEdit(report) {
      let routerData = this.$router.resolve({
        name: "toxicology-test-results",
        params: {
          result_file_id: report.result_file_id,
          report_id: report.report_id,
          test_results_id: report.test_results_id,
        },
        query: {
          // Spread the full current query so every list-view param (filters,
          // pagination, sort order, and the originating tab via redirectRoute)
          // survives the edit round-trip and can be restored when marking for
          // physician after Update & Preview.
          ...this.$route.query,
          origin: "test_reports",
          case_id: this.caseId,
          selected_panel: "TOXICOLOGY",
        },
      });
      window.location.href = routerData.href;
    },
    async getCaseTestsInfo() {
      this.showTestReport = false;
      try {
        await this.$store.dispatch(
          "cases/fetchCaseTestsInfo",
          this.$route.params.case_id
        );
        this.testInformation = this.getSingleCaseTestsInfo || [];
        let labOrderCodes = this.getSingleCaseTestsInfo
          ?.filter(
            (a) => a.panel_code != "SEND_OUTS" && a.panel_code != "ALL_TESTS"
          )
          .map((e) => {
            return e.lab_order_code;
          });
        let testCodes = this.getSingleCaseTestsInfo
          ?.filter((a) => a.panel_code === "ALL_TESTS")
          .map((e) => {
            return e.test_code;
          });
        testCodes = [...new Set(testCodes)];
        labOrderCodes = [...new Set(labOrderCodes)];
        this.testInformation = [...testCodes, ...labOrderCodes];
      } catch (error) {
        console.error("Error fetching case tests info:", error);
      }
    },
    async getUrinalysisTestsResults() {
      try {
        await this.$store.dispatch("cases/fetchAllUrineTestResults", {
          caseId: this.$route.params.case_id,
        });
        await this.$store.dispatch("cases/fetchUrineMachineResults", {
          accession_id: this.getCaseInformation.accession_id,
        });
        if (this.getUrineTestResults && this.getUrineTestResults.urineTest) {
          this.urineTestResults = this.getUrineTestResults.urineTest;
        }
        if (
          this.getUrineMachineResults &&
          this.getUrineMachineResults.results
        ) {
          this.urineTestResults = this.getUrineMachineResults.results;
        }
        let nullTestsBloodResults = this.urineTestResults
          .filter((b) => b.result_value === null || b.result_value === "")
          .map((a) => ({
            panel_code: a.test_name, // or use a.test_id if needed
            panel_title: a.test_name,
            test_name: a.result_name,
          }));
        this.filteredNullResults = [...nullTestsBloodResults];
      } catch (error) {
        console.log("Error fetching case tests info:", error);
      }
    },
    async getBloodTestResults() {
      try {
        await this.$store.dispatch("cases/fetchBloodTestResults", {
          caseId: this.$route.params.case_id,
        });
        this.bloodResults = this.getAllTestResults?.data?.results || [];
        let orderCodes = this.getSingleCaseTestsInfo.map((e) => ({
          test_name: e.test_name,
          panel_code: e.panel_code,
          panel_title: e.panel_title,
        }));
        let mappedArray = this.bloodResults
          .filter((e) => e.result !== null)
          .map((e) => ({
            category_code: e.category_code,
            lis_test_name: e.lis_test_name,
            result: e.result,
          }));
        this.bloodResults = this.bloodResults.map((e) => {
          return e.order_code;
        });
        this.bloodResults = [...new Set(this.bloodResults)];
        this.filteredNullResults = this.getAllTestResults?.data?.results
          .filter((e) => e.result === null)
          .map((e) => ({
            test_name: e.lis_test_name,
            result: e.result,
          }));
        const bloodResultsKeys = new Set();
        mappedArray.forEach((item) => {
          const key = `${item.category_code}_${item.lis_test_name}`;
          bloodResultsKeys.add(key);
        });
        // 2. Filter orderCodes based on these keys
        this.filteredNullResults = orderCodes.filter((order) => {
          const key = `${order.panel_code}_${order.test_name}`;
          return !bloodResultsKeys.has(key);
        });
        const frequencyMap = {};
        this.getAllTestResults?.data?.results.forEach((item) => {
          const name = item.lis_test_name;
          frequencyMap[name] = (frequencyMap[name] || 0) + 1;
        });
        let duplicateTestNames = Object.keys(frequencyMap).filter(
          (name) => frequencyMap[name] > 1
        );
        let nullResultRecords = this.getAllTestResults?.data?.results
          .filter(
            (e) =>
              e.result === null &&
              e.category_code === "ALL_TESTS" &&
              e.result_name?.toLowerCase() !==
                e.test_name_code?.toLowerCase() &&
              duplicateTestNames.includes(e.lis_test_name)
          )
          .map((a) => ({
            panel_code: a.test_name_code,
            panel_title: a.order_code,
            test_name: a.result_name,
          }));
        this.filteredNullResults = this.filteredNullResults.filter(
          (a) => !duplicateTestNames.includes(a.test_name)
        );
        this.filteredNullResults = [
          ...this.filteredNullResults,
          ...nullResultRecords,
        ];
      } catch (error) {
        console.error("Error fetching case tests info:", error);
      }
    },
    async checkCaseInformation() {
      this.showTestReport = false;
      this.loading = true;

      this.caseId = this.$route.params.case_id || this.caseIdProp;

      if (!this.caseId) {
        this.loading = false;
        this.$router.push({ to: "/cases" });
        return;
      }

      if (!this.caseData) {
        await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);
      }

      if (!this.getCaseInformation) {
        this.$router.push({ path: "all-cases" });
        this.loading = false;
        return;
      }

      this.caseStatus = this.getCaseInformation.status;

      if (
        this.getCaseInformation?.case_types?.includes("CLINICAL_CHEMISTRY") &&
        this.checkColonyLab
      ) {
        // sequential — blood results depend on case tests info
        await this.getCaseTestsInfo();
        await this.getBloodTestResults();
      }

      if (this.getCaseInformation.patient_info) {
        this.patientSectionClear = true;
        // URINALYSIS prefetch and reports are independent — run in parallel
        await Promise.all([
          this.getCaseInformation?.case_types?.includes("URINALYSIS")
            ? this.getUrinalysisTestsResults()
            : Promise.resolve(),
          this.fetchReports(),
        ]);
      } else {
        this.patientSectionClear = false;
      }

      this.loading = false;
    },
    async fetchReports() {
      this.loading = true;

      await this.$store.dispatch("cases/fetchCaseTestReports", {
        case_id: this.caseId,
      });

      if (this.getTestReportsData && this.getTestReportsData.length) {
        this.testReports = JSON.parse(JSON.stringify(this.getTestReportsData));

        this.testReports = this.testReports.sort((a, b) => {
          return moment(b.time).valueOf() - moment(a.time).valueOf();
        });
        // Build tabs from the unique case_types found in the reports themselves,
        // so that reports whose case_type is not listed in getCaseInformation.case_types
        // (e.g. STI, WOMENS_HEALTH alongside UTI) are still shown.
        const reportCaseTypes = [
          ...new Set(this.testReports.map((r) => r.case_type)),
        ];

        this.caseTypes = reportCaseTypes.map((e) => {
          return {
            case_type: e,
            name: caseConstants.CASE_TYPE_MAP[e],
            reports: this.testReports.filter(
              (report) => report.case_type === e
            ),
          };
        });

        this.patientData = this.getCaseInformation.patient_info;
        this.showTestReport = true;
        if (
          this.testReports &&
          this.testReports.length &&
          this.caseTypes &&
          this.caseTypes.length
        ) {
          this.activeName = 0 + "";
        } else {
          this.activeName = "uploadFiles";
        }

        const selectedPanel = this.$route.query.selected_panel;
        if (selectedPanel) {
          let index = this.caseTypes.findIndex(
            (x) => x.case_type == selectedPanel
          );
          this.activeName = index > -1 ? index + "" : "uploadFiles";
        } else if (
          !this.hasPermission("cases", "report_view") &&
          this.caseTypes &&
          this.caseTypes.length
        ) {
          this.activeName = this.caseTypes[0].case_type + "";
        } else {
          // this.activeName = "uploadFiles";
        }
      } else {
        this.caseTypes = [];
        this.showTestReport = false;
        this.activeName = "uploadFiles";
      }
      this.loading = false;
      if (this.caseStatus == "COMPLETE") {
        if (this.activeName == "uploadFiles") {
          this.activeName = 0 + "";
        }
      } else if (this.displayUploading == false) {
        if (this.activeName == "uploadFiles") {
          this.activeName = 0 + "";
        }
      }
    },
    async onDownload(report) {
      await this.$store.dispatch("respiratoryFileUpload/fetchFileDownloadUrl", {
        path: "test_reports/" + report.test_report_source,
      });
      let url = this.getFileDownloadUrl.download_url;

      await this.renameAndDownloadFile(url, report.title);

      if (this.hasPermission("test_reports", "update_download_status")) {
        await this.$store.dispatch("cases/updateTestReportDownloadStatus", {
          case_id: this.caseId,
          report_id: report._id,
        });
        await this.fetchReports();
      }
    },
    async onDownloadReport(report, skipDownload = false, showSuccess = true) {
      try {
        this.loading = true;
        this.loadingText = "Downloading Report....";
        if (report.download_ready) {
          if (
            report.is_manually ||
            report.download_ready ||
            report.additional_report_already_merged
          ) {
            await this.downloadManuallyUploadedFile(report);
          } else {
            await this.generateReport(report, skipDownload, showSuccess);
          }
        } else {
          await this.generateReport(report, skipDownload, showSuccess);
          await this.fetchReports();
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async downloadWhileMarkForPhysician(report) {
      let source = report.test_report_source;
      await this.$store.dispatch("cases/fetchTestReportDownloadURL", {
        path: "test_reports/" + source,
      });
    },
    async downloadManuallyUploadedFile(report) {
      let source = report.test_report_source;
      await this.$store.dispatch("cases/fetchTestReportDownloadURL", {
        path: "test_reports/" + source,
      });
      if (this.getDownloadReportData) {
        this.testReportsDownloadLog(report);
      }
      if (this.getDownloadReportData.data.download_url) {
        successNotification("Test Report Downloaded Successfully");
      } else if (!this.getDownloadReportData) {
        errorNotification(
          this.getError || "Error while downloading test report"
        );
      }
      let url = this.getDownloadReportData.data.download_url;
      const fileName = `${
        this.getCaseInformation.patient_info
          ? this.getCaseInformation.patient_info.first_name +
            " " +
            this.getCaseInformation.patient_info.last_name
          : ""
      } ${this.caseTypeMap[this.getCaseInformation.case_types[0]]}.pdf`; // Custom filename
      const fileStream = await axios({
        url: url,
        method: "GET",
        responseType: "blob", // important
      });

      const urlObject = window.URL || window.webkitURL;
      const downloadUrl = urlObject.createObjectURL(fileStream.data);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      await this.checkCaseInformation();
    },
    async fetchFileDownloadUrl(report) {
      await this.$store.dispatch("respiratoryFileUpload/fetchFileDownloadUrl", {
        path: "test_reports/" + report.test_report_source,
      });
      return this.getFileDownloadUrl.download_url;
    },
    getReportLoadingId(report) {
      return (
        report &&
        (report._id ||
          report.report_id ||
          report.result_file_id ||
          report.test_results_id)
      );
    },
    async viewReport(report) {
      this.viewReportLoadingId = this.getReportLoadingId(report);

      try {
        await this.generateReport(report, true, false);
        if (
          report.is_manually ||
          report.additional_report_merged ||
          report.additional_report_already_merged ||
          report.download_ready
        ) {
          let routerData = this.$router.resolve({
            name: "supplementaryReportView",
            params: {
              report_id: report._id,
              case_id: this.getCaseInformation._id,
            },
          });
          this.testReportsViewLog(report);
          await this.checkCaseInformation();
          window.open(routerData.href, "_blank");
        } else {
          let routerData = this.$router.resolve({
            name: "ResultFileReport",
            params: {
              result_file_id: report.result_file_id,
              report_id: report.report_id,
              test_results_id: report.test_results_id,
            },
          });
          this.testReportsViewLog(report);
          await this.checkCaseInformation();
          window.open(routerData.href, "_blank");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.viewReportLoadingId = null;
      }
    },
    async generateReport(report, skipDownload = false, showSuccess = true) {
      try {
        await this.$store.dispatch("cases/generateTestReport", {
          accession_id: this.getCaseInformation.accession_id,
          case_type: report.case_type,
          report_id: report.report_id,
          test_results_id: report.test_results_id,
          result_file_id: report.result_file_id,
          skip_download: skipDownload,
        });

        if (this.getReportGenerateStatus && showSuccess) {
          successNotification("Test Report Downloaded Successfully");
        } else if (!this.getReportGenerateStatus) {
          errorNotification(
            this.getError || "Error while downloading test report"
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    async onDelete(report) {
      try {
        this.$prompt(
          "Are you sure to delete the Test report? Please mention reason",
          "Warning",
          {
            confirmButtonText: "Submit",
            cancelButtonText: "Cancel",
            inputPlaceholder: "Reason to delete",
            inputValidator: (value) => {
              return value.trim().length == 0 ? "Reason is required" : true;
            },
          }
        ).then(async ({ value }) => {
          await this.deleteTestReport(report, value);
        });
      } catch (err) {
        console.log(err);
      }
    },
    async deleteTestReport(report, reason) {
      try {
        this.loading = true;
        let params = {
          case_id: this.caseId,
          report_id: report._id,
          data_delete_reason: reason,
        };
        await this.$store.dispatch("cases/deleteTestReport", params);
        this.loading = false;
        if (this.getReportDeleteStatus) {
          successNotification("Test report deleted successfully");
          await this.fetchReports();
        } else {
          errorNotification("Error at deleting test report");
        }
      } catch (err) {
        this.loading = false;
        console.error(err);
      }
    },
    isCriticalPositiveAssay(assay) {
      return Boolean(this.getCriticalPositiveAssayName(assay));
    },
    getCriticalPositiveAssayName(assay) {
      if (!assay) return null;

      // An assay is an STI target when the STI-panel marker `devansh_uti3` is
      // exactly "false" (a "true" value is NOT an STI target), it is not an
      // antibiotic-resistance gene, and it is not fungi (`devansh_uti3_fungi`).
      const isStiTarget =
        String(assay.devansh_uti3) === "false" &&
        assay.antibiotic_resistance !== true &&
        assay.devansh_uti3_fungi === undefined;
      if (!isStiTarget) return null;

      const result = (assay.result || "").toString().toUpperCase().trim();
      const summary = (assay.summary || "").toString().toUpperCase().trim();

      if (result === "POSITIVE" || summary === "DETECTED") {
        return (
          assay.display_name ||
          assay.assay_name ||
          assay.long_name ||
          assay.assay_id ||
          null
        );
      }

      return null;
    },
    getCriticalPositiveAssayNames(resultAssays) {
      return [...new Set(
        (resultAssays || [])
          .map((assay) => this.getCriticalPositiveAssayName(assay))
          .filter(Boolean)
      )];
    },
    buildPatientResultsPayload() {
      const c = this.getCaseInformation || {};
      if (c.is_sendout) return null;
      const api4Types = ["UTI", "STI", "WOMENS_HEALTH", "RESPIRATORY_PATHOGEN_PANEL"];
      const types = c.case_types || [];
      const matchedType = types.find((t) => api4Types.includes(t));
      if (!matchedType) return null;
      const pi = c.patient_info || {};
      const dob = (pi.date_of_birth || "").split("T")[0] || null;
      if (!pi.first_name || !pi.last_name || !dob) return null;
      return {
        case_type: matchedType,
        firstName: pi.first_name,
        lastName: pi.last_name,
        dob,
        gender: pi.gender || "",
        lab_code: c.lab?.lab_code || "",
      };
    },
    async fetchPatientResultsFallback() {
      const payload = this.buildPatientResultsPayload();
      if (!payload) return [];
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_SERVICES_URL}/patientResults`,
          payload
        );
        const data = res.data;
        return Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : [];
      } catch (err) {
        console.error("Error fetching patient results:", err);
        return [];
      }
    },
    async shouldConfirmCriticalPatientResults(report) {
      if (report && report.result_summary && report.result_summary.result_assays) {
        const criticalAssayNames = this.getCriticalPositiveAssayNames(
          report.result_summary.result_assays
        );
        if (criticalAssayNames.length) return criticalAssayNames;
      }

      // Prefer results already fetched by the parent (ViewCase); fall back to a
      // one-time fetch here if the prop wasn't provided/populated.
      let items = Array.isArray(this.patientResults) ? this.patientResults : [];
      if (!items.length) {
        items = await this.fetchPatientResultsFallback();
      }
      const latestResult = [...items].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      )[0];
      return this.getCriticalPositiveAssayNames(
        latestResult?.result_summary?.result_assays || []
      );
    },
    async confirmCriticalPatientResultsIfNeeded(status, report) {
      if (!status) return true;
      const criticalAssayNames = await this.shouldConfirmCriticalPatientResults(report);
      if (!criticalAssayNames.length) return true;

      // Show the positive STI target display names on hover of "One or more".
      const hoverNames = criticalAssayNames
        .join(", ")
        .replace(/"/g, "&quot;");

      try {
        await ElMessageBox.confirm(
          `<span title="${hoverNames}" style="color: #d03050; text-decoration: underline dotted; cursor: pointer;">One or more</span> STI targets are Positive. Do you want to finalize the report?`,
          "Confirm",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        );
        return true;
      } catch (err) {
        return false;
      }
    },
    async confirmUrinalysisUtiDiscrepancyIfNeeded(status, report) {
      const caseType = (report.case_type || "").toUpperCase();
      if (!status || !["UTI", "URINALYSIS"].includes(caseType)) {
        return true;
      }

      try {
        const resultId = report._id;
        if (!resultId) {
          errorNotification("Unable to validate report: result ID is missing");
          return false;
        }

        let response;
        this.validatingResultId = resultId;
        try {
          response = await this.$store.dispatch(
            "cases/validateResultBeforeFinalizing",
            {
              case_id: this.caseId,
              result_id: resultId,
            }
          );
        } finally {
          this.validatingResultId = null;
        }
        if (response?.data !== true) return true;

        await ElMessageBox.confirm(
          "Urinalysis is Negative while UTI targets are Positive. Do you want to finalize the report?<br><br><strong>UA Result Status:</strong> Negative",
          "",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        );
        return true;
      } catch (err) {
        if (err !== "cancel" && err !== "close") {
          errorNotification("Unable to validate the report");
        }
        return false;
      }
    },
    async updateReportPhysicianStatus(status, report) {
      try {
        const discrepancyConfirmed = await this.confirmUrinalysisUtiDiscrepancyIfNeeded(
          status,
          report
        );
        if (!discrepancyConfirmed) return;

        const canContinue = await this.confirmCriticalPatientResultsIfNeeded(
          status,
          report
        );
        if (!canContinue) return;

        if (
          this.getCaseInformation &&
          this.getCaseInformation?.is_labdaq_order &&
          this.isDLWLab &&
          this.isSendoutCategory &&
          this.getCaseInformation.case_types.includes("CLINICAL_CHEMISTRY") &&
          !this.isSuperAdmin
        ) {
          await this.$store.dispatch(
            "resultFiles/fetchmissmatchresultsForlabdaqOrders",
            {
              case_id: this.caseId,
              report_id: report._id,
            }
          );
          this.DiscretemissingTests =
            this.getDiscreteResultsMismatchedTests || [];
          if (this.DiscretemissingTests.length > 0) {
            this.ismissmatchedResultsPopup = true;
            return;
          }
        }
        // if (
        //   this.filteredNullResults &&
        //   this.filteredNullResults.length > 0 &&
        //   this.getCaseInformation.case_types.includes("CLINICAL_CHEMISTRY") &&
        //   status &&
        //   this.checkColonyLab
        // ) {
        //   this.filteredResults = [
        //     ...new Set(
        //       this.filteredNullResults.map(
        //         (test) => test.test_name || "Unnamed Test"
        //       )
        //     ),
        //   ];
        //   this.is_forced = status;
        //   this.is_report = report;
        //   this.resultMismatchedPopup = true;
        // } else
         if (
          this.filteredNullResults &&
          this.filteredNullResults.length > 0 &&
          this.getCaseInformation.case_types.includes("URINALYSIS") &&
          status
        ) {
          this.filteredResults = [
            ...new Set(
              this.filteredNullResults.map(
                (test) => test.test_name || "Unnamed Test"
              )
            ),
          ];
          this.resultMismatchedPopup = true;
        } else {
          // If URINALYSIS sendout, show confirmation to remove from sendout
          if (
            status &&
            this.getCaseInformation &&
            this.getCaseInformation.is_sendout &&
            Array.isArray(this.getCaseInformation.case_types) &&
            this.getCaseInformation.case_types.includes("URINALYSIS")
          ) {
            this.pendingPhysicianToggle = { status, report };
            this.showSendoutRemovePopup = true;
            return;
          }
          // When marking for physician, show acknowledge dialog only if case has notes
          if (
            status &&
            this.getCaseInformation &&
            this.getCaseInformation.report_notes &&
            this.getCaseInformation.report_notes.length > 0
          ) {
            this.pendingPhysicianMarkReport = report;
            this.showPhysicianAcknowledgeDialog = true;
            return;
          }
          await this.finaliseReport(status, report);
        }
      } catch (err) {
        console.error(err);
        this.$notify.error({
          title: "Error",
          message: "Error at updating physician status",
        });
      }
    },
    async updateReportToClientStatus(value, report) {
      try {
        this.loading = true;
        const params = {
          case_id: this.caseId,
          report_id: report._id,
        };
        await this.$store.dispatch("cases/updateReportClientStatus", params);
        await this.checkCaseInformation();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        errorNotification("Failed to update report client status");
      }
    },
    chooseResendFaxOptions(report) {
      this.selectedFaxReport = report;
      this.resendFaxConfig.hospital =
        this.getCheckFaxStatus.hospital_fax_status;
      this.resendFaxConfig.referring_physician =
        this.getCheckFaxStatus.referring_physician_fax_status;
      if (
        this.getCaseInformation.additional_fax &&
        this.getCaseInformation.additional_fax.length
      ) {
        this.resendFaxConfig.additional_fax_numbers =
          this.getCaseInformation.additional_fax;
        this.faxOptions = this.getCaseInformation.additional_fax;
      }
      if (this.getSingleHospital && this.getSingleHospital.fax) {
        this.resendFaxConfig.additional_fax_numbers.push(
          this.getSingleHospital.fax
        );
      }
      this.resendFaxConfig.additional_fax_numbers = Array.from(
        new Set(this.resendFaxConfig.additional_fax_numbers)
      );
      this.$store.commit("errors/clear", null, { root: true });
      this.askResendFaxConfigOptions = true;
    },
    handleResendFaxConfigClose() {
      this.askResendFaxConfigOptions = false;
      this.selectedFaxReport = null;
      this.resendFaxConfig.referring_physician = true;
      this.resendFaxConfig.hospital = true;
    },
    async resendFax() {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/sendFax", {
          case_id: this.getCaseInformation._id,
          report_id: this.selectedFaxReport._id,
          params: this.resendFaxConfig,
        });
        if (this.getFaxSentStatus) {
          successNotification("Fax Sent Successfully");
          this.handleResendFaxConfigClose();
          window.location.reload();
        } else {
          errorNotification(this.getError || "Error in sending Fax");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    async finaliseReport(status, report, isRerunAcknowledged = false) {
      try {
        let params = {
          status,
          case_id: this.caseId,
          report_id: report._id,
          covid_status: report.covid_status || null,
        };

        if (isRerunAcknowledged) {
          params.is_rerun_acknowledged = true;
        }

        if (!status) {
          await this.askUnmarkReason(params, status, report);
        } else {
          // await this.downloadWhileMarkForPhysician(report);
          const navigated = await this.updateReportStatus(
            params,
            status,
            report
          );
          // Only fall back to $router.back() when updateReportStatus didn't
          // already redirect (e.g. to AllCases). Otherwise back() would undo
          // that redirect and return the user to the toxicology edit page.
          if (!this.missedToxicologyPopup && !navigated) {
            this.$router.back();
          }
        }
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "Error",
          message: "Error at updating physician status",
        });
      }
    },
    async askUnmarkReason(params, status, report) {
      this.$prompt(
        "Are you sure to unmark the test report for physician?",
        "Warning",
        {
          confirmButtonText: "Submit",
          cancelButtonText: "Cancel",
          inputPlaceholder: "Reason to unmark",
          inputPattern: /^.{3,}/,
          inputErrorMessage: "Reason must be 3 charcters",
          inputValidator: (value) => {
            return value.trim().length == 0
              ? "Reason must be 3 charcters"
              : true;
          },
        }
      )
        .then(async ({ value }) => {
          params.data_update_reason = value;
          // await this.downloadWhileMarkForPhysician(report);
          await this.updateReportStatus(params, status);
        })
        .catch(async () => {
          await this.fetchReports();
        });
    },
    openNotesDialog() {
      this.noteForm = { title: "", description: "" };
      this.showNotesDialog = true;
    },
    closeNotesDialog() {
      this.showNotesDialog = false;
      this.noteForm = { title: "", description: "" };
    },
    applyNotePredefined(option) {
      this.noteForm.title = option.label;
      this.noteForm.description = option.description;
    },
    async submitNote() {
      if (!this.noteForm.title || !this.noteForm.description) {
        this.$notify.warning({ title: "Warning", message: "Title and description are required" });
        return;
      }
      this.noteSubmitLoading = true;
      await this.$store.dispatch("cases/addCaseReportNote", {
        case_id: this.caseId,
        title: this.noteForm.title,
        description: this.noteForm.description,
      });
      this.noteSubmitLoading = false;
      if (this.getTestReportNoteAdded) {
        successNotification("Note added successfully");
        this.closeNotesDialog();
        await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);
      } else {
        errorNotification("Failed to add note");
      }
    },
    async onPhysicianAcknowledge() {
      const report = this.pendingPhysicianMarkReport;
      this.showPhysicianAcknowledgeDialog = false;
      this.pendingPhysicianMarkReport = null;
      await this.finaliseReport(true, report, true);
    },
    onPhysicianAcknowledgeCancel() {
      this.showPhysicianAcknowledgeDialog = false;
      this.pendingPhysicianMarkReport = null;
      // Revert switch UI by re-fetching reports
      this.fetchReports();
    },
    formatNoteDate(date) {
      return date ? moment(date).format("MM/DD/YYYY hh:mm A") : "";
    },
    redirectAfterFinalize() {
      if (this.$route.query && this.$route.query.redirectRoute) {
        const query = { ...this.$route.query };
        const redirectRoute = this.$route.query.redirectRoute;
        delete query.redirectRoute;
        this.$router.push({ name: redirectRoute, query });
      } else {
        this.$router.push({
          name: "AllCases",
          query: {
            ...this.$route.query,
            redirectRoute: this.$route.name,
          },
        });
      }
    },
    async updateReportStatus(params, status, report = null) {
      this.selectedReport = null;
      this.loading = true;
      if (!params.covid_status) delete params.covid_status;

      if (
        report &&
        Object.prototype.hasOwnProperty.call(report, "_delete_sendout")
      ) {
        params.delete_sendout = !!report._delete_sendout;
      }
      await this.$store.dispatch(
        "cases/updateTestReportPhysicianStatus",
        params
      );
      if (this.getReportPhysicianStatusUpdated) {
        successNotification(
          `Report ${
            status ? "Marked" : "Un-Marked"
          } for the physician successfully`
        );
        if (status) {
          this.selectedReport = report;
          if (
            this.getReportPhysicianStatusData &&
            this.getReportPhysicianStatusData.ua_to_uti_reflex &&
            this.getReportPhysicianStatusData.ua_to_uti_reflex == true
          ) {
            await this.handleUTICaseCreation();
          } else if (
            this.getReportPhysicianStatusData &&
            this.getReportPhysicianStatusData.cc_reflex &&
            this.getReportPhysicianStatusData.cc_reflex == true
          ) {
            await this.handleCCCaseCreation();
            this.redirectAfterFinalize();
          } else if (
            this.getReportPhysicianStatusData &&
            this.getReportPhysicianStatusData.check_urine_culture_reflex &&
            this.getReportPhysicianStatusData.check_urine_culture_reflex == true
          ) {
            await this.handleUrineCultureCaseCreation();
            this.redirectAfterFinalize();
          } else {
            this.redirectAfterFinalize();
          }
          // Navigation was handled above (reflex creation or redirect to
          // AllCases/redirectRoute); signal the caller so it does not also
          // call $router.back(), which would land the user back on the edit
          // page instead of the cases list. This now covers reports that are
          // finalized without being auto-generated or manual (e.g. toxicology
          // in-house results, where getReportGenerateStatus/is_manually are
          // falsy).
          return true;
        } else {
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      } else if (
        this.getPhysicianValidations &&
        this.getPhysicianValidations.error_code &&
        this.getPhysicianValidations.error_code == "REPORT_NOT_FINALIZED"
      ) {
        ElMessageBox.alert("Report Not Finalized", "Message", {
          confirmButtonText: "OK",
          callback: () => {
            window.location.reload();
          },
        });
      } else if (
        this.getPhysicianValidations &&
      this.getPhysicianValidations.error_code &&
        this.getPhysicianValidations.error_code === "TESTS_NOT_FOUND"
      ) {
        const metadata = this.getPhysicianValidations.metadata || [];
        const testsMessage = metadata.length
          ? `<span style="color: red;">${metadata.join(", ")}</span>`
          : "";
        const alertMessage = testsMessage
          ? `BELOW TESTS ARE NOT FOUND IN RESULTS.<br> ${testsMessage}`
          : "TESTS ARE NOT FOUND IN RESULTS.";
        ElMessageBox.alert(alertMessage, "WARNING", {
          confirmButtonText: "OK",
          dangerouslyUseHTMLString: true,
        });
      } else if (
        this.getPhysicianValidations &&
        this.getPhysicianValidations.error_code &&
        this.getPhysicianValidations.error_code == "SEND_OUT_IS_NOT_ALLOWED"
      ) {
        ElMessageBox.alert("SEND OUT IS NOT ALLOWED", "WARNING", {
          confirmButtonText: "OK",
          callback: () => {
            window.location.reload();
          },
        });
      } else {
        if (this.hasToxicology && report) {
          this.missedToxicologyTests = this.getError
            .replace("Missing reports:", "")
            .trim()
            .split(/\s*,\s*/);
          this.missedToxicologyPopup = true;
        } else {
          errorNotification(
            this.getError || "Error at Updating report updating for physician"
          );
        }
        this.loading = false;
      }
    },
    closeMissedToxicologyDialog() {
      this.missedToxicologyPopup = false;
      this.missedToxicologyTests = [];
    },
    checkEditDisable(report, checkAllReports = true) {
      let caseType = report.case_type;
      if (this.caseStatus == "COMPLETE") {
        this.editBlockReason = "This case is already finalized";

        return true;
      }

      return report.mark_for_physician == true ? true : false;
    },
    handleAdditionalReportsClose() {
      this.$confirm("Are you sure want to Cancel?")
        .then(async () => {
          this.files = [];
          this.additionalReportsPopup = false;
        })
        .catch(() => {});
    },
    //UTI case creation
    async handleUTICaseCreation() {
      // Directly call the createCase method without confirmation popup
      await this.$confirm(
        "Select 'Proceed to UTI test' once the urinalysis test is positive.",
        "Acknowledgment",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      )
        .then(async () => {
          // createCase handles notifications based on the action response
          await this.createCase();
          await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);
          await this.fetchReports();
        })
        .catch(() => {});
    },
    async createCase() {
      try {
        this.loading = true;
        let params = {
          case_id: this.getCaseInformation._id,
        };
        const response = await this.$store.dispatch(
          "cases/createUTICase",
          params
        );
        const sendoutStatus =
          response?.data?.data?.sendoutCreated ||
          response?.sendoutCreated ||
          false;
        await this.$nextTick();
        if (this.getUtiCaseCreationStatus) {
          if (response?.data?.pending_case) {
            successNotification(
              response?.data?.message ||
                "UTI case moved to approval pending cases"
            );
          } else {
            successNotification("UTI Case Created Successfully");
          }
        } else {
          errorNotification(this.getError || "Error in creating UTI case");
        }
        this.loading = false;
        return response;
      } catch (err) {
        this.loading = false;
        console.log(err);
        errorNotification(this.getError || "Error in creating UTI case");
        return null;
      }
    },
    async handleCCCaseCreation() {
      // Directly call the createCCCase method without confirmation popup
      const orderCodes = this.getReportPhysicianStatusData.original_testgo_cc_order_codes || [];
      // const codesDisplay = orderCodes.length ? orderCodes.join(", ") : "N/A";
      // await this.$confirm(
      //   `For Order Codes: ${codesDisplay}. Proceed to create CC SENDOUT case?`,
      //   "CC Reflex",
      //   {
      //     confirmButtonText: "Yes",
      //     cancelButtonText: "Cancel",
      //     type: "warning",
      //   }
      // )
      //   .then(async () => {
      //     await this.createCCCase(orderCodes);
      //   })
      //   .catch(() => {});
      await this.createCCCase(orderCodes);
    },
    async handleUrineCultureCaseCreation() {
      // Directly call the createUrineCultureCase method without confirmation popup
      const orderCodes = this.getReportPhysicianStatusData.original_testgo_order_codes || [];
      // const codesDisplay = orderCodes.length ? orderCodes.join(", ") : "N/A";
      // await this.$confirm(
      //   `For Order Codes: ${codesDisplay}. Proceed to create Urine Culture SENDOUT case?`,
      //   "Urine Culture Reflex",
      //   {
      //     confirmButtonText: "Yes",
      //     cancelButtonText: "Cancel",
      //     type: "warning",
      //   }
      // )
      //   .then(async () => {
      //     await this.createUrineCultureCase(orderCodes);
      //   })
      //   .catch(() => {});
      await this.createUrineCultureCase(orderCodes);
    },
    async createUrineCultureCase(originalTestgoOrderCodes) {
      try {
        this.loading = true;
        const params = {
          case_id: this.getCaseInformation._id,
          original_testgo_order_codes: originalTestgoOrderCodes,
        };
        await this.$store.dispatch("cases/createUrineCultureCase", params);
        if (this.getUrineCultureCaseCreationStatus) {
          successNotification("Urine Culture Case Created Successfully");
        } else {
          errorNotification(this.getError || "Error in creating Urine Culture case");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        errorNotification(this.getError || "Error in creating Urine Culture case");
      }
    },
    async createCCCase(originalTestgoOrderCodes) {
      try {
        this.loading = true;
        const params = {
          case_id: this.getCaseInformation._id,
          original_testgo_cc_order_codes: originalTestgoOrderCodes,
        };
        await this.$store.dispatch("cases/createCCCase", params);
        if (this.getCCCaseCreationStatus) {
          successNotification("CC Case Created Successfully");
        } else {
          errorNotification(this.getError || "Error in creating CC case");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        errorNotification(this.getError || "Error in creating CC case");
      }
    },
    preparePatientInfoForSendReport(report) {
      let params = {
        path: report.test_report_source,
        case_type: report.case_type,
        patient_info: this.getCaseInformation.patient_info,
        accession_id: this.getCaseInformation.accession_id,
      };
      return params;
    },
    formatPanelName(panelCode) {
      return panelCode
        .replace(/_/g, " ")
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    restrictRefreshReportAccess(caseData, user, report) {
      const userNames = ["kalyantech"];
      const userRoles = ["LAB_TECHNOLOGIST"];
      const allowedCaseTypes = ["STI", "UTI", "TOXICOLOGY", "WOMENS_HEALTH" ,"COVID", "RESPIRATORY_PATHOGEN_PANEL",  "URINALYSIS" , "CLINICAL_CHEMISTRY" ];
      return (
        userNames.includes(user?.username) &&
        userRoles.includes(user?.user_type) &&
        caseData &&
        caseData.is_amendement &&
        caseData.status === "TEST_REPORTS" &&
        !report?.is_supplemental_report &&
        allowedCaseTypes.includes(report?.case_type)
      );
    },
  },
};
</script>
<style lang="scss">
.case-creation__heading {
  overflow: hidden;
}

#view-test-information {
  .test-reports {
    display: grid;
    grid-template-columns: 200px auto;
    column-gap: 15px;

    // height: 25px;
    .el-switch .el-switch__core {
      width: 34px !important;
      height: 14.5px;
      border: none;
      background-color: #0a5da6;

      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2px;
        left: 2.1px;
      }
    }

    .el-switch__label.is-active {
      color: #0a5da6;
    }

    .el-switch.is-checked {
      .el-switch__core {
        background-color: #4bb543 !important;
      }

      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2px;
        left: 38px;
      }
    }

    .single-reports {
      margin-left: 20px;
    }
  }

  .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
  }

  .test-tabs {
    // padding: 0 10px;

    .el-tabs__nav-scroll {
      padding: 0 15px;
    }

    .el-tabs__nav-wrap::after {
      height: 1px;
    }

    .test-panel {
      padding: 10px;

      .title-icon {
        padding: 0 6px;
        min-height: 20px;
        border: none;
        background: none;

        img {
          vertical-align: text-top;
        }
      }

      .icons {
        display: flex;
        justify-content: flex-end;
        padding: 2px 7px 12px 7px;

        .el-button {
          padding: 0;
          min-height: 21px;
          border: none;
          background: none;
        }

        .el-icon {
          .icon {
            width: 18px;
            height: 18px;
            color: #2979ff;
            padding-top: 3px;
          }

          &.cancel {
            margin-left: 8px;
          }
        }
      }
    }

    .el-tabs__active-bar {
      background-color: #0a5da6;
      border-radius: 25px;

      height: 2px;
    }

    .el-tabs__item.is-active {
      color: #0a5da6;
      font-weight: 500;
    }

    .el-tabs__item:hover {
      color: #828282;
    }

    .el-tabs__item {
      color: #828282;
    }

    .el-table {
      .el-table__cell {
        .cell {
          font-weight: 500 !important;
        }
      }
    }

    .types {
      padding-top: 1rem;

      .el-form-item {
        display: block !important;
        margin: 0;
      }

      .case-type {
        &.view-reports-dialog {
          .el-button {
            border: 1px dashed #bababc;
            min-height: 30px;
            padding: 0 34px;
            background-color: #f2f6f9;
            width: 100%;
            font-size: 11px;

            span {
              display: flex;
              align-items: center;
              justify-content: center;
              color: #333333;

              p {
                color: #333333;
                font-weight: 400;
              }

              img {
                margin-right: 6px;
              }
            }
          }
        }

        .el-input__inner {
          border: 1px solid #56ccf2cc;
          height: 30px;
        }
      }

      .btn {
        margin-top: 22px;

        .el-button {
          color: #fff;
          padding: 8px 24px;
          min-height: 30px;
          border-radius: 7px;
          background: linear-gradient(
            79.26deg,
            #f24a55 -13.43%,
            #0a5da6 137.71%
          );
          border: none;
        }

        .submit-report {
          color: #fff;
          padding: 8px 24px;
          min-height: 30px;
          border-radius: 7px;
          background: linear-gradient(
            79.26deg,
            #f24a55 -13.43%,
            #0a5da6 137.71%
          );
          border: none;
        }
      }
    }

    .view-test {
      display: flex;
      font: icon;
      align-items: center;

      .el-button {
        padding: 0;
        margin-right: 10px;
        min-height: 20px;
        border: none;
        background: none;
      }

      .resend-notify-button {
        color: #10182f;
        margin-right: 7px;
        padding: 4px 0;
        border-radius: 5px;

        &:hover {
          color: #0a5da6;
        }

        &.replace {
          padding: 4px 8px;
          border: 1px solid #273480;

          &:hover {
            color: #273480;
            padding: 4px 8px;
            border: 1px solid #273480;
          }
        }
      }

      .discrete-results-btn {
        color: #737373;
        padding: 0;
        font-weight: 600;
        border-radius: 5px;

        &:hover,
        &:focus,
        &:active {
          color: #c5314c;
          padding: 0;
          font-weight: 600;
          border-radius: 5px;
          transform: scale(1.1);
        }
      }
    }

    .test-panel {
      padding: 10px;

      .el-table {
        background: #eef2f5;

        // padding: 0 10px;
        .el-table__cell {
          padding: 5px 0;
        }
      }

      .el-table__header {
        border-spacing: 0 2.5px;
        color: rgba(0, 0, 0, 0.8);
      }

      .el-table__body {
        border-spacing: 0 2.5px;
      }

      .el-table__body-wrapper {
        overflow: initial !important;
      }

      .el-table__header-wrapper {
        overflow: initial !important;
      }

      .el-table thead {
        color: rgba(0, 0, 0, 0.8);
        font-weight: 500;
      }

      .hours {
        margin-left: 10px;
      }

      .el-icon-edit {
        min-height: 25px;
        padding: 0 5px;
        background-color: #f24a55;
        color: #ffff;
        border: none;
      }

      .edit-icon {
        cursor: pointer;
        position: relative;

        top: 3px;
      }
    }
  }

  .fax-resend-popup {
    .el-form-item {
      display: grid;
      grid-template-columns: 45% 55%;
      margin-bottom: 5px;
    }

    .el-form-item__label {
      text-align: start;
      padding: 0 20px;
      width: 250px !important;
    }

    .el-tag {
      margin-right: 7px;
    }

    .additionalFaxSelect {
      .el-select .el-select__tags > span {
        display: block !important;
      }

      .el-select {
        width: 92% !important;
      }

      .el-select__tags {
        flex-wrap: wrap !important;
      }
    }
  }

  .notes-btn {
    margin-top: 5px;
    text-align: center;

    .btn {
      padding: 5px 7px;
      height: 22px;
      font-size: 12px;
      min-height: 22px;
      background-color: #273480;
      border: none;
      color: white;

      &.cancel {
        background-color: transparent;
        color: #f24a55;
        border: 0.719521px solid #dedbdb;
      }
    }
  }

  .physician-btn {
    .sample-run-location {
      display: inline-block;
      margin-left: 10px;
      padding: 2px 10px;
      border: 1px solid #d9363e;
      border-radius: 3px;
      background: #fdecea;
      color: #b3261e;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      white-space: nowrap;
      vertical-align: middle;
    }

    .el-switch .el-switch__core {
      width: 34px !important;
      height: 15px;
      border: none;
      background-color: #0a5da6;

      .el-switch__action {
        height: 9px;
        width: 9px;
        top: 3px;
        left: 2px;
      }
    }

    .el-switch__label.is-active {
      color: #0a5da6;
    }

    .el-switch.is-checked {
      .el-switch__core {
        width: 34px !important;
        height: 15px;
        border: none;
        background-color: #4bb543 !important;
      }

      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2.2px;
        left: 38.5px;
      }
    }
  }

  .tox-finalize-btn {
    margin-left: 20px;

    .el-button {
      border: 0.6px solid #273480;
      background: #f2f2f2;
      color: #273480;
      min-height: auto;
      padding: 5px 15px;
      text-align: center;
      font-size: 13px;
      letter-spacing: 0;

      &:hover,
      &:focus {
        color: #273480;
        border: 0.6px solid #273480;
        background: #f2f2f2;
      }
    }
  }

  .reflex-created-label {
    color: #67c23a;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    margin: 0 8px;
    display: inline-flex;
    align-items: center;
  }

  .upload-files-alignment-block {
    .upload-files-alignment {
      width: 100%;
      margin: auto;
      margin-bottom: 10px;
    }
  }

  .default-modal {
    .popup-date {
      .el-upload {
        width: 100%;
      }

      .upload-demo,
      .el-upload-dragger {
        width: 100%;
        margin: auto;
        height: 120px;
        background: #c4c4c41f !important;

        border: 0.6px dashed #c4c4c41f;
        border-radius: 6px;
      }

      .el-upload-text-align {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding-top: 30px;

        .el-upload__text-img {
          display: flex;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
            padding: 0 10px;
          }
        }

        .el-upload-text {
          line-height: 14px;

          h3 {
            color: #333333;
            font-size: 18px;
          }

          p {
            color: #828282;
            font-size: 18px;
          }
        }
      }
    }
  }

  .active-report-new {
    .el-table tr {
      background-color: red !important;
    }
  }
}

.no-test-block {
  color: #f24a55;
  display: flex;
  align-items: center;
  text-emphasis: center;
  height: 60px;
  justify-content: center;
}

.reportsTableWidth {
  .el-table {
    table {
      width: 100% !important;
    }
  }

  .el-table__body-wrapper {
    width: 100% !important;
  }
}

.no_Data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  color: #ff0000;
}

#discrete_results_view_popup {
  .default-modal .el-dialog__body {
    border-radius: 5px;
    height: 540px;

    .all-cases-view {
      max-height: 480px;
      overflow-y: auto;
    }
  }

  .listings__table .el-table table {
    border-collapse: separate;
    border-spacing: 0px 5px;
  }

  .listings__table .el-table table tbody tr td .cell {
    line-height: 25px;
    padding: 3px 10px !important;
  }

  .listings__table .el-table table thead tr th.el-table__cell {
    padding: 0.65em 0 0.5em 0 !important;
    background: #273480 !important;
  }

  .listings__table .el-table table thead tr th .cell {
    color: #fff;
    padding: 3px 10px !important;
  }
}

#clinical-results-view-popup {
  .default-modal {
    .el-overlay-dialog {
      overflow: hidden;
    }
  }

  .default-modal .el-dialog__body {
    border-radius: 5px;
    height: 540px;

    .all-cases-view {
      height: 445px;
      overflow-y: auto;
    }
  }

  .listings__table .el-table {
    height: auto !important;
  }

  .listings__table .el-table table {
    border-collapse: separate;
    border-spacing: 0px 5px;
  }

  .listings__table .el-table--scrollable-x .el-table__body-wrapper {
    overflow-x: hidden;
    overflow-y: hidden;
    height: auto !important;
  }

  .listings__table .el-table--scrollable-y .el-table__body-wrapper {
    height: auto !important;
  }

  .listings__table .el-table table tbody tr td .cell {
    line-height: 25px;
    padding: 3px 10px !important;
  }

  .listings__table .el-table table thead tr th.el-table__cell {
    padding: 0.3rem 0 0.3rem 0 !important;
    background: #273480 !important;
  }

  .listings__table .el-table table thead tr th .cell {
    color: #fff;
    padding: 3px 10px !important;
  }

  .listings__table .el-table table tbody tr td.el-table__cell {
    padding: 0;
    border: none;
    border-right: transparent;
    border-left: none !important;
  }

  .listings__table .el-table table tbody tr td:last-child {
    border-right: none !important;
  }

  .clinical_results_table {
    .category-header-row {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 12px;
      flex-wrap: wrap;

      .testgo-map-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 280px;

        .testgo-map-label {
          font-size: 12px;
          font-weight: 600;
          color: #303133;
          display: flex;
          align-items: center;
          gap: 6px;

          .testgo-required-star {
            color: #f56c6c;
            font-weight: 700;
          }

          .testgo-unmapped-badge {
            font-size: 10px;
            font-weight: 600;
            color: #f56c6c;
            background: #fef0f0;
            border: 1px solid #fbc4c4;
            border-radius: 3px;
            padding: 0 6px;
            line-height: 16px;
          }
        }
      }

      .testgo-code-select {
        min-width: 280px;

        &.is-unmapped .el-input__inner {
          border-color: #f56c6c !important;
          background: #fff8f8;
        }
      }
    }
    .el-input__inner {
      background: #ffffff;
      padding-right: 25px !important;
      padding-left: 5px;
      color: #000;
      border: 0.922417px solid rgba(156, 156, 156, 0.5);
      font-weight: 500;
      font-size: 13px;
      height: 28px;
      box-sizing: border-box;
      border-radius: 3.56227px;

      &::placeholder {
        color: #bdbdbd;
        opacity: 0.8;
        font-weight: 500;
        font-size: 13px;
        letter-spacing: 0;
      }
    }
  }
}
#missing-test-results-popup {
  .default-modal {
    .popup-date {
      padding: 0.5rem 1rem;
      &.missing-test-results {
        max-height: 400px;
        overflow: auto;
        .panel-group {
          h4 {
            font-size: 16px;
            font-weight: 600;
            color: #10182f;
            margin: 0;
            padding: 0.5rem 0;
          }
        }
        ol {
          padding-left: 1.2rem;
          margin: 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.5rem;
        }
      }
    }
    .dialog-footer {
      padding: 5px !important;
    }
  }
}

#view-test-information {
  .report-notes-panel {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    padding: 5px 14px;
    border-bottom: 1px solid #ebebeb;
    background: #fff;

    .notes-label {
      font-size: 11px;
      font-weight: 600;
      color: #9a9a9a;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      margin-right: 2px;
    }

    .note-chip {
      display: inline-block;
      background: #fffde7;
      border: 1px solid #e6c800;
      border-radius: 3px;
      padding: 1px 8px;
      font-size: 11px;
      font-weight: 500;
      color: #5a4800;
      cursor: pointer;
      white-space: nowrap;

      &:hover {
        background: #fff8c5;
        border-color: #c8a800;
      }
    }

    .note-add-trigger {
      font-size: 11px;
      font-weight: 600;
      color: #273480;
      cursor: pointer;
      padding: 1px 6px;
      border-radius: 3px;
      white-space: nowrap;

      &:hover {
        background: #eef0fa;
      }
    }
  }
}
</style>

<style>
.note-popover-content {
  padding: 2px 0;
}
.note-popover-desc {
  font-size: 13px;
  color: #333;
  margin: 0 0 8px;
  line-height: 1.5;
}
.note-popover-meta {
  font-size: 11px;
  color: #888;
  margin: 0;
}
</style>
